import React, { useEffect, useState, useRef } from "react";
import { Input, Dropdown, Button, Checkbox, AddRemove, AccordionWrapper } from "../utils";
import { buttonClasses } from "../utils/theme";
import { useOrgs, useUserDetail, useDevices, usePlant, useUserPermissions, useCheckpoints } from "../../services/hooks";
import { useProductCategories, useProducts, useSuppliers } from "../../services/hooks";
import {
	useAddCheckPointMutation,
	useGetApiListDetailQuery,
	useUpdateCheckPointMutation,
	useGetCheckpointTypeMutation,
	useGetWorkflowListMutation,
	useGetVariableListingMutation,
	useGetApprovalConfigMutation,
} from "../../api/vmsSlice";
import { toastMessage } from "../utils";
import "./CheckpointIndex.css";
import { useGetTemplateListQuery } from "../../api/vmsSlice";
import ListingConfigration from "./ListingConfigration";
import { capitalizeCamelCase } from "../../services/functions";
import { Tooltip } from "@mui/material";
import { DragIndicatorIcon, InfoIcon } from "../../services/icons";
import { DndProvider, useDrag, useDrop } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { usePlantContext } from "../../context/plantContext";

const checkpointType = [
	{ label: "Access", value: "access" },
	{ label: "Gate In", value: "gateIn" },
	{ label: "Parking", value: "parking" },
	{ label: "Bay", value: "bay" },
	{ label: "Weighbridge", value: "weighbridge" },
	{ label: "Gate Out", value: "gateOut" },
];

const defaultFilter = {
	// pagesize: 40,
	// page_no: 1,
};

const postFunctionOption = [
	// { label: "Update TripWorkflow", value: "updateTripWorkflow" },
	// {label: "Auto Parking", value: "updateTripForParking"},
	// {label: "Create Next Approval", value: "createNextApproval"},
	{label: "Update Trip For GateIn CWC", value: "updateTripForGateIn"},
]

const itemTypeOption = [
	{ label: "Product", value: "product" },
	{ label: "Product Category", value: "productCategory" },
	{ label: "Supplier", value: "supplier" },
	{ label: "Custom", value: "custom" },
];

const itemTypeOption2 = [
	{ label: "Product", value: "product" },
	{ label: "Product Category", value: "productCategory" },
	{ label: "Supplier", value: "supplier" },
];

const DEFAULT_LISITINGCONFIG = [
	{
		type: "arrived",
		order: 1,
		label: "Arrived",
		filter: [
			{
				key: "status",
				selfFilter: true,
				formula: {
					operator: "object",
					eval: [
						{
							key: "$gte",
							isDynamic: false,
							value: "1",
						},
					],
				},
			},
		],
	},
];

const accessoriesArray = Object.entries({}).map(([accessoriesName, accessoriesData], index) => ({
	accessoriesName,
	accessoriesData: {
		...accessoriesData,
		eventypes: [{ type: "", duration: 0 }],
		order: index + 1,
	},
}));

const DEFAULT_LED_CONFIGURATION = {
	ledDetails: {
		ledId: "",
		eventTypes: [
			{
				type: "",
				lineOne: "",
				lineTwo: "",
				variableList: [],
				order: 0, // For TWOLINE LED
				duration: 0, // For TWOLINE LED
				generatorFunction: "", // For TENLINE LED
				parameters: [""], // For TENLINE LED
			},
		],
	},
	isActive: false,
};
const DEFAULT_SPEAKER_CONFIGURATION = {
	speakerDetails: {
		speakerId: "",
		eventTypes: [
			{
				type: "",
				lineOne: "",
				variableList: [],
			},
		],
	},
	isActive: false,
};

const DEFAULT_EVENT_TPYE_OPTION = [
	{ label: "In", value: "in" },
	{ label: "Approval", value: "approval" },
	{ label: "Out", value: "out" },
];
const DEFAULT_ASSET_CONFIG = {
	assetAdd: false,
	assetScan: false,
};
const defaultSetupFunctionOption=[
	{label:"Classify Vehicle", value:"classifyVehicle"},
]
export default function CreateCheckpoint() {
	const location = useLocation();
	const updatedData = location.state?.updatedData;
	const isDuplicate = location.state?.isDuplicate;
	const filterData = location.state?.filterData;
	const isUpdate = location.pathname.includes("edit");
	const navigate = useNavigate();
	const { userDetail, isSuperAdmin } = useUserDetail();
	const { userPermissions, isFetched } = useUserPermissions();
	const { plantId: selectedPlantId, plantName: selectedPlantName } = usePlantContext();
	const shouldHandlePlant = isSuperAdmin || userPermissions?.managePlant?.value;

	const { orgOptions, orgs } = useOrgs();
	const { plantOptions, getPlantDetails, clearPlants } = usePlant();
	useEffect(() => {
		if (userPermissions?.managePlant?.value) {
			getPlantDetails({});
		}
	}, [userPermissions]);
	// const { userPermissions } = useUserPermissions();

	// console.log({ assetAddPerm, assetScanPerm });
	const filterRef = useRef(defaultFilter);
	const templateRef = useRef({});
	const devicesRef = useRef({ pagesize: 10, page_no: 1 });
	// const { devices, getDevices } = useDevices(devicesRef.current);
	const { devices, getDevices } = useDevices();
	const { data: templateList, refetch: refetchTemplate } = useGetTemplateListQuery(templateRef.current, { refetchOnMountOrArgChange: true });
	// const { productCategories, count, isLoading, message, getProdCats } = useProductCategories(filterRef.current);
	const { productCategories, count, isLoading, message, getProdCats } = useProductCategories();

	// const { products, count: productCount, getProducts } = useProducts(filterRef.current);

	const { products, count: productCount, getProducts } = useProducts();
	// const { suppliers, count: supplierCount, getSuppliers } = useSuppliers(filterRef.current);
	const { suppliers, count: supplierCount, getSuppliers } = useSuppliers();

	const { data: ApiOption, error: apilistError, isLoading: apilistLoading } = useGetApiListDetailQuery({});
	const [checkpointTypeTrigger, { data: checkPointTypeData, error: checkPointTypeError, isLoading: checkPointTypeLoading }] = useGetCheckpointTypeMutation();
	const [handleAddCheckPoint, { isLoading: isUpdating }] = useAddCheckPointMutation();
	const [handleUpdateCheckPoint] = useUpdateCheckPointMutation();
	const [variableListTrigger] = useGetVariableListingMutation();
	// console.log('checkPointTypeOption', devices);
	const [variableListing, setVariableListing] = useState([]);
	const [listingConfig, setListingConfig] = useState(DEFAULT_LISITINGCONFIG);

	const [addCustomListingConfig, setAddCustomListingConfig] = useState(false);

	const [checkPoint, setCheckPoint] = useState({
		orgId: "",
		orgName: "",
		plantId: "",
		checkpointNumber: "",
		checkpointType: "",
		checkpointStatus: "",
		displayName: "",
		templateId: "",
		approvalRequired: false,
		apiMethod: "post",
		api: "vms/vehicle/create-vehicle-entry",
		detailApi: "vms/vehicle/vehicle-entry-data-list",
		latitude: "",
		longitude: "",
		detailApiMethod: "post",
		deallocateTag: false,
		entryPoint: false,
		exitPoint: false,
		isBidirectional: false,
		createTripsThroughStrayFastags: false,
		defaultWorkflowId: "",
		allowMultipleEntry: false,
		customizeTripWorkflow: false,
		holdDuration: 30,
		validateCheckoutTime: false,
		entrySequence: [], // [{checkpointNumber: 1, _id, displayName}]
		isCustomEndPoint: false,
		setupFunction:"",
		postFunction:"",
		tripResetTimeLimit: 0,
		gateOutOverrideMins: 0
	});
	const { checkpoints } = useCheckpoints();
	const entrySequenceOpts = checkpoints.map((_) => ({ label: _.displayName, value: _._id, data: _ }));

	const { permissions = {} } = orgs.find((_) => _._id == checkPoint.orgId) || {};
	const assetAddPerm = permissions.assetAdd?.value;
	const assetScanPerm = permissions.assetScan?.value;
	// console.log('checkPoint', assetAddPerm, assetScanPerm, permissions)
	const [approvalConfig, setApprovalConfig] = useState({
		sendApproval: false,
		dependentApproval: false,
		approvaldependancy: [{ itemType: "", id: [], approvalId: "" }],
		approvalId: "",
	});
	const [scanConfig, setScanConfig] = useState({
		deviceScannning: false,
		deviceId: "",
		antennaId: undefined,
	});
	const [cameraConfig, setCameraConfig] = useState([]);

	const [assetConfig, setAssetConfig] = useState(DEFAULT_ASSET_CONFIG);
	const [checkoutConfig, setCheckoutconfig] = useState({
		api: "vms/vehicle/checkout-vehicle",
		apiMethod: "post",
		buttonLabel: "",
		buttonClass: "",
		submitFormTitle: "",
		templateId: "",
		checkoutOnSubmit: false,
		autoCheckout: false,
		checkoutOnApproval: false,
		checkoutWhenOutOfRange: false,
		entrySuccessText: "",
		checkoutHoldDuration: 0,
		hideInTime: false,
		hideOutTime: false,
		inTimeLabel: "In Time",
		outTimeLabel: "Out Time",
		isCheckoutCustomEndPoint: false,
	});

	// const [accessories, setAccessories] = useState(DEFAULT_ACCESSORIES);
	const [accessories, setAccessories] = useState(accessoriesArray);

	const [LEDConfig, setLEDConfig] = useState(DEFAULT_LED_CONFIGURATION);
	const [speakerConfig, setSpeakerConfig] = useState(DEFAULT_SPEAKER_CONFIGURATION);
	const [error, setError] = useState({
		checkPoint: {},
		listingConfig: [],
		approvalConfig: {},
		scanConfig: {},
		checkoutConfig: {},
		ledConfig: {},
		speakerConfig: {},
		accessories: {},
	});

	const [getWorkflowListTrigger, { isLoadingg }] = useGetWorkflowListMutation();
	const [workflowListing, setWorkFlowListing] = useState([]);
	useEffect(() => {
		if (isUpdate && !updatedData) {
			navigate("/checkpoints/edit-checkpoint");
		}
	}, []);
	const logPatternArray = devices.find((ele) => ele.imei === scanConfig?.deviceId)?.logPattern;
	const matchedItem = logPatternArray?.find((item) => /^(gpi?o)$/i.test(item.commandCode || ""));
	let gpoOptions = matchedItem
		? Object.entries(matchedItem)
				.filter(([key]) => !["commandCode", "logTime"].includes(key))
				.map(([key, value]) => ({ label: capitalizeCamelCase(key), value: key }))
		: [];

	const orgValue = orgOptions.find((ele) => ele.value === checkPoint.orgId) || null;
	const plantValue = plantOptions.find((ele) => ele.value === checkPoint.plantId) || null;
	const plantName = plantValue?.label || "";
	const cameraOptions = devices?.length > 0 ? devices.filter((ele) => ele.deviceType === "camera").map((ele) => ({ label: ele.displayName, value: ele.imei })) : [];

	const fetchWorkFlowListing = (payload = {}) => {
		getWorkflowListTrigger(payload)
			.unwrap()
			.then((res) => {
				// console.log('res==', res)
				if (res?.data) {
					const option = res.data.map((_) => ({ label: _.name, value: _._id }));
					setWorkFlowListing(option);
					// setCount(res.count)
					// setFilter((previousValue) => ({ ...previousValue, count: res.count }));
				}
				if (res.error == true) {
					// toastMessage(false, res.message);
					setWorkFlowListing([]);
				}
			})
			.catch((err) => {
				// toastMessage(false, err.message);
				setWorkFlowListing([]);
			});
	};

	const [getApprovalConfigsTrigger] = useGetApprovalConfigMutation({});
	const [approvalConfigOptions, setApprovalConfigOptions] = useState([]);

	const fetchApprovalConfigurations = (payload = {}) => {
		getApprovalConfigsTrigger(payload)
			.unwrap()
			.then((res) => {
				if (res.data) {
					const options = res.data.map((_) => ({ label: _.module, value: _._id }));
					setApprovalConfigOptions(options);
				} else {
					setApprovalConfigOptions([]);
				}
			})
			.catch((err) => setApprovalConfigOptions([]));
	};

	const addApprovalDependancyListing = () => {
		// const logList = JSON.parse(JSON.stringify([...listingConfig]));
		// const approvalDependancyList = { ...approvalConfig }
		const approvalDependancyList = JSON.parse(JSON.stringify({ ...approvalConfig }));
		approvalDependancyList.approvaldependancy.push({ itemType: "", id: [] });
		setApprovalConfig(approvalDependancyList);
	};
	const RemoveApprovalDependancyListing = (index) => {
		// const approvalDependancyList = { ...approvalConfig }
		const approvalDependancyList = JSON.parse(JSON.stringify({ ...approvalConfig }));
		approvalDependancyList.approvaldependancy.splice(index, 1);
		setApprovalConfig(approvalDependancyList);
	};

	const onHandleCheckpointDetailChange = (option, name) => {
		// console.log("value", value, name);
		let value = Array.isArray(option) ? option.map((_) => _.value) : typeof option == "object" ? option?.value || "" : option;

		const checkPointDetail = { ...checkPoint };
		if (name === "entryPoint" && value === false) {
			checkPointDetail["defaultWorkflowId"] = "";
			checkPointDetail["createTripsThroughStrayFastags"] = false;
		}
		if (name === "checkpointStatus") {
			const filters = [
				{
					type: "arrived",
					order: 1,
					label: "Arrived",
					filter: [
						{
							key: "status",
							selfFilter: true,
							formula: {
								operator: "object",
								eval: [
									{
										key: "$gte",
										isDynamic: false,
										value: value,
									},
								],
							},
						},
					],
				},
			];
			if (!addCustomListingConfig && listingConfig.length === 1) {
				setListingConfig(filters);
			}
		} else if (name === "orgId") {
			checkPointDetail["orgName"] = option?.label;
			checkPointDetail["plantId"] = "";
			checkPointDetail["templateId"] = "";
			checkPointDetail["checkpointType"] = "";
			checkPointDetail["defaultWorkflowId"] = "";
			// console.log("orgName", option.label);

			templateRef.current = { organization_id: value };
			refetchTemplate(templateRef.current);
			checkpointTypeTrigger({ orgId: value });
			variableListTrigger({ orgId: value })
				.unwrap()
				.then((res) => {
					if (!res.error) {
						const variableList = res.data[0].variableList.map((_) => ({ label: _, value: _ }));
						setVariableListing(variableList);
					} else {
						setVariableListing([]);
					}
				})
				.catch((err) => {
					setVariableListing([]);
				});
			fetchApprovalConfigurations({ orgId: value });
			setScanConfig({
				deviceScannning: false,
				deviceId: "",
				antennaId: "",
			});
			setCameraConfig([]);
			setCheckoutconfig((prev) => ({
				...prev,
				checkoutWhenOutOfRange: false,
				templateId: "",
			}));
			if (shouldHandlePlant) {
				if (value) {
					getPlantDetails({ orgId: value });
				} else {
					clearPlants();
				}
			}
		} else if (name === "plantId") {
			devicesRef.current = { plantIds: value };
			getProdCats({ ...defaultFilter, plantIds: value });
			getProducts({ ...defaultFilter, plantIds: value });
			getSuppliers({ ...defaultFilter, plantIds: value });
			fetchWorkFlowListing(value ? { plantIds: value } : {});
			getDevices(devicesRef.current);
			checkPointDetail["defaultWorkflowId"] = "";
			setScanConfig({
				deviceScannning: false,
				deviceId: "",
				antennaId: "",
			});
			setCameraConfig([]);
			setCheckoutconfig((prev) => ({
				...prev,
				checkoutWhenOutOfRange: false,
			}));
			if (userDetail?.userType !== "superAdmin") {
				checkpointTypeTrigger({ orgId: userDetail?.orgId });
			}
		} else if (name == "isBidirectional") {
			if (value) {
				checkPointDetail.approvalRequired = false;
				setApprovalConfig({
					sendApproval: false,
					dependentApproval: false,
					approvaldependancy: [{ itemType: "", id: [], approvalId: "" }],
					approvalId: "",
				});
			}
		} else if (name == "entrySequence") {
			value = option.map((_) => ({ checkpointNumber: _.data?.checkpointNumber, displayName: _.data?.displayName, _id: _.data?._id }));
		}

		checkPointDetail[name] = value;
		// console.log("checkPointDetail==>>", checkPointDetail);
		setCheckPoint(checkPointDetail);
	};

	const onhandleApprovalConfigration = (value, name, index) => {
		if (name === "itemType") {
			// const approvalConfigDetail = { ...approvalConfig };
			const approvalConfigDetail = JSON.parse(JSON.stringify({ ...approvalConfig }));
			// console.log("approoval ====", value);
			if (value === null || value === undefined) {
				approvalConfigDetail.approvaldependancy[index][name] = "";
			} else {
				approvalConfigDetail.approvaldependancy[index][name] = value.value;
				if (value.value === "productCategory") {
					getProdCats({ ...defaultFilter, plantIds: checkPoint.plantId });
				}
				if (value.value === "product") {
					getProducts({ ...defaultFilter, plantIds: checkPoint.plantId });
				}
				if (value.value === "supplier") {
					getSuppliers({ ...defaultFilter, plantIds: checkPoint.plantId });
				}
			}

			setApprovalConfig(approvalConfigDetail);
			// console.log('approval', value, name, index)
		}

		if (name === "id") {
			// console.log('checkpoint detail===', value, name, index);
			// console.log('approvalConfigdetail===', approvalConfig);
			const approvalConfigDetail = JSON.parse(JSON.stringify({ ...approvalConfig }));
			// const approvalConfigDetail = { ...approvalConfig };
			const itemList = value.map((ele) => {
				if (ele.value) {
					return ele.value;
				} else {
					return ele;
				}
			});
			// console.log("itemList ====", itemList);
			approvalConfigDetail.approvaldependancy[index][name] = itemList;
			setApprovalConfig(approvalConfigDetail);
		}

		if (name === "approvalId") {
			const approvalConfigDetail = JSON.parse(JSON.stringify({ ...approvalConfig }));
			approvalConfigDetail.approvaldependancy[index][name] = value ?? "";
			setApprovalConfig(approvalConfigDetail);
		}
	};

	const onhandleConfigration = (value, name, config) => {
		const scanConfigDetail = { ...scanConfig };
		const checkoutConfigDetail = { ...checkoutConfig };
		let approvalConfigDetail = { ...approvalConfig };
		if (config === "checkpointConfig") {
			if (value === null || value === undefined) {
				checkoutConfigDetail[name] = "";
			} else if (value.constructor === Object) {
				checkoutConfigDetail[name] = value.value;
			} else {
				checkoutConfigDetail[name] = value;
			}
		} else if (config === "approvalConfig") {
			if (name == "sendApproval") {
				approvalConfigDetail = {
					sendApproval: value,
					dependentApproval: false,
					approvaldependancy: [{ itemType: "", id: [], approvalId: "" }],
				};
			} else if (name == "dependentApproval" && value == false) {
				// console.log("dependentApproval", name, value);
				approvalConfigDetail = {
					sendApproval: true,
					dependentApproval: false,
					approvaldependancy: [{ itemType: "", id: [], approvalId: "" }],
				};
			} else {
				if (name == "approvalId" && (value == null || value == undefined)) {
					approvalConfigDetail[name] = "";
				} else {
					approvalConfigDetail[name] = value;
				}
			}
		} else if (config == "assetConfig") {
			setAssetConfig((o) => ({ ...o, [name]: value }));
		} else {
			// console.log(value, name, config);
			if (value == undefined && name == "deviceId") {
				scanConfigDetail[name] = value || "";
				scanConfigDetail["antennaId"] = value || "";
			} else {
				if (name == "deviceScannning" && value == false) {
					checkoutConfigDetail.checkoutWhenOutOfRange = false;
					scanConfigDetail.deviceId = "";
					scanConfigDetail.antennaId = "";
					setCameraConfig([]);
				}
				scanConfigDetail[name] = name == "antennaId" && value == undefined ? "" : value;
			}
		}
		setScanConfig(scanConfigDetail);
		setCheckoutconfig(checkoutConfigDetail);
		setApprovalConfig(approvalConfigDetail);
	};

	const handleSubmit = (action) => {
		// console.log(listingConfig);
		const newlistingConfig = ensureValueIsArray(JSON.parse(JSON.stringify(listingConfig)));
		// console.log(newlistingConfig);
		const filteredAccessories = accessories.filter(({ accessoriesName }) => accessoriesName?.trim());
		const accessoriesArrayToObject = filteredAccessories.reduce((acc, { accessoriesName, accessoriesData }) => {
			acc[accessoriesName] = accessoriesData;
			return acc;
		}, {});
		const cameraIds = cameraConfig.filter((id) => id !== "");
		const plantValue = plantOptions.find((ele) => ele.value === checkPoint.plantId) || null;
		const plantName = plantValue?.label || (!isSuperAdmin && selectedPlantId === checkPoint.plantId ? selectedPlantName : "");
		// Added this for those cases in which the plantName is going as emtpy string 
		if (isSuperAdmin && checkPoint.plantId && !plantValue) {
			setError((prev) => ({
				...prev,
				checkPoint: {
					...prev.checkPoint,
					plantId: "Please reselect warehouse",
				},
			}));
			toastMessage(false, "Please reselect warehouse.");
			return;
		}
		const cleanLEDConfig = (config) => {
			if (!config.isActive || !config.ledDetails.ledId) {
				return {
					isActive: false,
					ledDetails: {
						ledId: "",
						eventTypes: [],
						duration: 0,
						order: 1,
					},
				};
			}
			const cleaned = {
				...config,
				ledDetails: {
					...config.ledDetails,
					eventTypes: config.ledDetails.eventTypes.map((eventType) => {
						const baseEvent = {
							type: eventType.type,
							...(config.ledDetails.deviceSubType === "TENLINE"
								? {
										generatorFunction: eventType.generatorFunction,
										parameters: eventType.parameters.filter((p) => p !== ""), // Remove empty parameters
								  }
								: {
										lineOne: eventType.lineOne,
										lineTwo: eventType.lineTwo,
										duration: eventType.duration || 0,
										order: eventType.order || 1,
										variableList: eventType.variableList ? eventType.variableList.filter((item) => item && item.trim() !== "") : [],
								  }),
						};
						return baseEvent;
					}),
				},
			};
			return cleaned;
		};
		const normalizedScanConfig = scanConfig.deviceScannning
			? scanConfig
			: {
					...scanConfig,
					deviceId: "",
					antennaId: "",
			  };
		const normalizedCameraIds = scanConfig.deviceScannning ? cameraIds : [];
		let payload = {
			...checkPoint,
			plantName: plantName,
			listingConfig: newlistingConfig,
			...approvalConfig,
			...normalizedScanConfig,
			cameraId: normalizedCameraIds,
			checkoutConfig,
			accessories: {
				...accessoriesArrayToObject,
				triggerLED: cleanLEDConfig(LEDConfig),
				triggerSpeaker: speakerConfig,
			},
			assetConfig,
		};
		payload.orgName = orgValue?.label;
		// console.log(payload);
		// const checkValidation = { success: true };
		const checkValidation = validatePayload({
			checkPoint: { ...checkPoint, orgName: orgValue?.label || userDetail?.orgName, orgId: checkPoint.orgId || userDetail?.orgId },
			listingConfig: listingConfig,
			approvalConfig: approvalConfig,
			scanConfig: scanConfig,
			checkoutConfig: checkoutConfig,
			accessories: {
				...accessories,
				triggerLED: LEDConfig,
				triggerSpeaker: speakerConfig,
			},
		});

		// console.log({ checkValidation });
		if (checkValidation.success) {
			setError({
				checkPoint: {},
				listingConfig: [],
				approvalConfig: {},
				scanConfig: {},
				checkoutConfig: {},
				ledConfig: {},
			});
			// console.log("submit==", payload);
			if (action === "submit") {
				handleAddCheckPoint(payload)
					.unwrap()
					.then((res) => {
						toastMessage(!res.error, res.message);
						if (!res.error) {
							navigate("/checkpoints", {
								state: {
									data: {
										createdCheckpoint: res?.data,
										users: res?.users,
									},
									assignUserModal: true,
									filterData: filterData,
								},
							});
						}
					})
					.catch((err) => {
						toastMessage(false, err.message);
					});
			} else {
				if (updatedData._id != "") {
					const updatedPayload = { ...payload, checkpointId: updatedData._id };
					// console.log(updatedPayload);
					handleUpdateCheckPoint(updatedPayload)
						.unwrap()
						.then((res) => {
							toastMessage(!res.error, res.message);
							if (!res.error) {
								navigate("/checkpoints", { state: { filterData: filterData } });
							}
						})
						.catch((err) => {
							toastMessage(false, err.message);
						});
				} else {
					toastMessage(false, "_id is missing");
				}
			}
		} else {
			// console.log("submit====", payload);
			setError(checkValidation.error);
			toastMessage(false, "Please check your input. Some fields are either empty or contain invalid values.");
		}
	};

	const handleViewMap = () => {
		const { latitude, longitude } = checkPoint;
		if (latitude !== null && longitude !== null) {
			// Redirect to Google Maps with the specified latitude and longitude
			window.open(`https://www.google.com/maps?q=${latitude},${longitude}`, "_blank");
		} else {
			alert("Latitude and Longitude are required.");
		}
	};

	useEffect(() => {
		if (updatedData && Object.keys(updatedData)?.length > 0) {
			// console.log("edit", updatedData?.accessories?.triggerLED);
			const updatedNewData = { ...updatedData };
			const updatedCheckPoint = {
				orgId: updatedNewData.orgId || "",
				orgName: updatedNewData.orgName || "",
				plantId: updatedNewData.plantId || "",
				checkpointNumber: updatedNewData.checkpointNumber || "",
				checkpointType: updatedNewData.checkpointType || "",
				checkpointStatus: updatedNewData.checkpointStatus || "",
				allowMultipleEntry: updatedNewData.allowMultipleEntry || false,
				customizeTripWorkflow: updatedNewData.customizeTripWorkflow || false,
				displayName: updatedNewData.displayName || "",
				templateId: updatedNewData.templateId || "",
				deallocateTag: updatedNewData.deallocateTag || false,
				approvalRequired: updatedNewData.approvalRequired || false,
				required: updatedNewData.required || false,
				apiMethod: updatedNewData.apiMethod || "",
				api: updatedNewData.api || "",
				latitude: updatedNewData.latitude || "",
				longitude: updatedNewData.longitude || "",
				detailApi: updatedNewData.detailApi || "",
				detailApiMethod: updatedNewData.detailApiMethod || "",
				entryPoint: updatedNewData.entryPoint,
				isBidirectional: updatedNewData.isBidirectional,
				exitPoint: updatedNewData.exitPoint,
				createTripsThroughStrayFastags: updatedNewData.createTripsThroughStrayFastags,
				defaultWorkflowId: updatedNewData.defaultWorkflowId || "",
				holdDuration: updatedNewData.holdDuration,
				tripResetTimeLimit: updatedNewData.tripResetTimeLimit,
				gateOutOverrideMins: updatedNewData.gateOutOverrideMins ?? 0,
				validateCheckoutTime: updatedNewData.validateCheckoutTime || false,
				entrySequence: updatedNewData.entrySequence,
				isCustomEndPoint: updatedNewData.isCustomEndPoint,
				setupFunction: updatedNewData?.setupFunction || "",
				postFunction: updatedNewData?.postFunction || "",
			};
			const updatedListingConfig = undoArrayToString(JSON.parse(JSON.stringify(updatedNewData?.listingConfig || listingConfig)));
			const updatedApprovalconfig = {
				sendApproval: updatedNewData.sendApproval || false,
				dependentApproval: updatedNewData.dependentApproval || false,
				approvaldependancy: updatedNewData.approvaldependancy || false,
				approvalId: updatedNewData.approvalId || "",
			};
			const updatedScanConfig = {
				deviceScannning: updatedNewData.deviceScannning || false,
				deviceId: updatedNewData.deviceId || "",
				antennaId: updatedNewData.antennaId || undefined,
			};
			const updatedCheckoutConfig = updatedNewData?.checkoutConfig ? updatedNewData?.checkoutConfig : checkoutConfig;
			devicesRef.current = { plantIds: updatedNewData.plantId };
			templateRef.current = { organization_id: updatedNewData.orgId };
			if (updatedData.accessories && typeof updatedData.accessories === "object") {
				const accessoriesArray = Object.entries(updatedData.accessories).map(([accessoriesName, accessoriesData], index) => ({
					accessoriesName,
					accessoriesData: { ...accessoriesData, order: accessoriesData.order || index + 1 },
				}));
				setAccessories(accessoriesArray || DEFAULT_ACCESSORIES);
			}

			const updatedLEDConfig = updatedData?.accessories?.triggerLED ? JSON.parse(JSON.stringify(updatedData.accessories.triggerLED)) : JSON.parse(JSON.stringify(DEFAULT_LED_CONFIGURATION));

			if (!updatedLEDConfig.ledDetails?.eventTypes || updatedLEDConfig.ledDetails.eventTypes.length === 0) {
				updatedLEDConfig.ledDetails = {
					...updatedLEDConfig.ledDetails,
					eventTypes: [
						{
							type: "",
							...(updatedLEDConfig.ledDetails.deviceSubType === "TENLINE"
								? {
										generatorFunction: "",
										parameters: [""], // Initialize with one empty parameter
								  }
								: {
										lineOne: "",
										lineTwo: "",
										variableList: [],
								  }),
						},
					],
				};
			} else if (updatedLEDConfig.ledDetails.deviceSubType === "TENLINE") {
				// Ensure all event types have parameters array if they don't
				updatedLEDConfig.ledDetails.eventTypes = updatedLEDConfig.ledDetails.eventTypes.map((eventType) => ({
					...eventType,
					parameters: eventType.parameters || [""], // Initialize if missing
				}));
			}
			const updatedSpeakerConfig = updatedData?.accessories?.triggerSpeaker
				? JSON.parse(JSON.stringify(updatedData.accessories.triggerSpeaker))
				: JSON.parse(JSON.stringify(DEFAULT_SPEAKER_CONFIGURATION));

			if (!updatedSpeakerConfig.speakerDetails?.eventTypes || updatedSpeakerConfig.speakerDetails.eventTypes.length === 0) {
				updatedSpeakerConfig.speakerDetails = {
					...updatedSpeakerConfig.speakerDetails,
					eventTypes: [
						{
							type: "",
							lineOne: "",
							variableList: [],
						},
					],
				};
			}

			setCameraConfig(updatedData?.cameraId?.length ? updatedData.cameraId : []);
			setSpeakerConfig(updatedSpeakerConfig);
			setLEDConfig(updatedLEDConfig);
			// console.log({t: templateRef.current})
			refetchTemplate();
			// fetchApprovalConfigurations({ orgId: updatedNewData.orgId });
			fetchApprovalConfigurations({ plantIds: updatedNewData.plantId });

			getDevices(devicesRef.current);
			checkpointTypeTrigger({ orgId: updatedNewData.orgId });
			// fetchWorkFlowListing({ orgId: updatedNewData.orgId });
			fetchWorkFlowListing({ plantIds: updatedNewData.plantId });
			setCheckPoint(updatedCheckPoint);
			setListingConfig(updatedListingConfig);
			setApprovalConfig(updatedApprovalconfig);
			setScanConfig(updatedScanConfig);
			setCheckoutconfig(updatedCheckoutConfig);
			// setAccessories(updatedData.accessories || DEFAULT_ACCESSORIES);
			// setLEDConfig(updatedData?.accessories?.triggerLED || DEFAULT_LED_CONFIG);
			// setSpeakerConfig(updatedData?.accessories?.triggerSpeaker || DEFAULT_SPEAKER_CONFIGURATION);
			setAssetConfig(updatedData.assetConfig || DEFAULT_ASSET_CONFIG);
			// getProdCats({ ...defaultFilter, orgId: updatedNewData.orgId });
			// getProducts({ ...defaultFilter, orgId: updatedNewData.orgId });
			// getSuppliers({ ...defaultFilter, orgId: updatedNewData.orgId });
			getProdCats({ ...defaultFilter, plantIds: updatedNewData.plantId });
			getProducts({ ...defaultFilter, plantIds: updatedNewData.plantId });
			getSuppliers({ ...defaultFilter, plantIds: updatedNewData.plantId });
			if (shouldHandlePlant) {
				getPlantDetails({ orgId: updatedNewData.orgId });
			}
			variableListTrigger({ orgId: updatedNewData.orgId })
				.unwrap()
				.then((res) => {
					if (!res.error) {
						const variableList = res.data[0].variableList.map((_) => ({ label: _, value: _ }));
						setVariableListing(variableList);
					} else {
						setVariableListing([]);
					}
				})
				.catch((err) => {
					setVariableListing([]);
				});
		}
		// console.log(updatedData)
	}, [updatedData]);
	// const ledLineOneIndices = findIndexForVariableList(LEDConfig?.ledDetails?.lineOne);
	// const speakerLineOneIndices = findIndexForVariableList(speakerConfig?.speakerDetails?.lineOne);
	const findIndexForVariableList = (str) => {
		if (!str) return [];
		const matches = [...str.matchAll(/\{(\d+)\}/g)];
		const uniqueMatches = [];
		const seenIndices = new Set();

		matches.forEach((match) => {
			const index = match[1]; // Get the number inside {}
			if (!seenIndices.has(index)) {
				seenIndices.add(index);
				uniqueMatches.push({
					element: match[0],
					index: parseInt(index),
				});
			}
		});

		return uniqueMatches;
	};
	const moveItem = (fromIndex, toIndex) => {
		const updated = [...displayAccessories];
		const [movedItem] = updated.splice(fromIndex, 1);
		updated.splice(toIndex, 0, movedItem);

		const withUpdatedOrder = updated.map((item, idx) => ({
			...item,
			accessoriesData: {
				...item.accessoriesData,
				order: idx + 1,
			},
		}));
		setAccessories(withUpdatedOrder);
	};
	if (!accessories.length) {
		setAccessories([
			{
				accessoriesData: { isActive: false, value: "", duration: 0, order: 1 },
				accessoriesName: "",
			},
		]);
	}
	const displayAccessories = accessories.filter(i => !["triggerLED", "triggerSpeaker"].includes(i.accessoriesName)).length === 0
  ? [...accessories, { accessoriesName: "", accessoriesData: { isActive: false, value: "", duration: 0, order: 1, eventTypes: [{ type: "", duration: 0 }] } }]
  : accessories;
	// console.log("camera config", cameraConfig)
	if (isFetched && userPermissions && Object.keys(userPermissions).length && !userPermissions.updateCheckpoint?.value && !userPermissions?.addCheckpoint?.value && !isSuperAdmin)
		return <Navigate to="/not-authorized" replace />;
	const handleGoBack = () => {
		navigate("/checkpoints", { state: { filterData: filterData || "" } });
	};
	return (
		<>
			<div className="cust-row flex-algn-cent">
				<div className="cust-col-5">
					<h1 className="title">{isUpdate ? "Update Checkpoint" : "Add Checkpoint"}</h1>
				</div>
				<div className="cust-col-5 flex-jc-end">
					<div>
						<Button className="" text="Go Back" style={buttonClasses.lynkitOrangeEmpty} onClick={handleGoBack} />
					</div>
				</div>
			</div>
			<hr className="bgg" />
			<div className="checkpoint-container">
				<div className="dropdown-div" style={{ marginTop: "10px", width: "450px", display: "flex", gap: "1rem" }}>
					{userDetail?.userType === "superAdmin" ? (
						<Dropdown
							id={"orgId"}
							name={"orgId"}
							value={orgValue}
							options={orgOptions}
							label={"Select Organisation"}
							onChange={(option, key) => {
								onHandleCheckpointDetailChange(option, key);
							}}
							required
							error={error?.checkPoint?.orgId}
						/>
					) : null}

					{shouldHandlePlant ? (
						<div style={{ minWidth: "250px", maxWidth: "300px" }}>
							<Dropdown
								id="plantIdAdd"
								name="plantId"
								value={plantValue}
								options={plantOptions}
								label="Select Warehouse"
								onChange={(option, key) => {
									onHandleCheckpointDetailChange(option, key);
								}}
								required
								error={error?.checkPoint?.plantId}
							/>
						</div>
					) : null}
				</div>
				<div className="mt-2">
					<h5 className="checkpoint_subHeading">Checkpoint detail</h5>
				</div>
				<div className="checkpoint-detail-container">
					<Input
						id={"checkpointNumber"}
						name={"checkpointNumber"}
						value={checkPoint.checkpointNumber}
						onChange={(e) => {
							onHandleCheckpointDetailChange(e.target.value, e.target.name);
						}}
						type={"number"}
						label={"Checkpoint Order No."}
						placeholder={"Enter Checkpoint Order No."}
						required
						step={1}
						error={error?.checkPoint?.checkpointNumber}
					/>
					<Input
						id={"displayName"}
						name={"displayName"}
						value={checkPoint.displayName}
						type={"text"}
						label={"Display Name"}
						onChange={(e) => {
							onHandleCheckpointDetailChange(e.target.value, e.target.name);
						}}
						required
						error={error?.checkPoint?.displayName}
					/>
					<div className="dropdown-div">
						<Dropdown
							id={"checkpointType"}
							name={"checkpointType"}
							value={
								checkPointTypeData && checkPointTypeData?.data && checkPointTypeData?.data?.length > 0
									? checkPointTypeData?.data
											?.filter((ele) => ele.checkpointType === checkPoint.checkpointType)
											.map((ele) => ({ label: ele.checkpointType, value: ele.checkpointType }))[0]
									: null
							}
							options={
								checkPointTypeData && checkPointTypeData?.data && checkPointTypeData?.data?.length > 0
									? checkPointTypeData?.data?.map((ele) => ({ label: ele.checkpointType, value: ele.checkpointType }))
									: []
							}
							label={"Checkpoint Type"}
							onChange={(option, key) => onHandleCheckpointDetailChange(option, key)}
							required
							error={error?.checkPoint?.checkpointType}
						/>
					</div>
					<Input
						id={"checkpointStatus"}
						name={"checkpointStatus"}
						value={checkPoint.checkpointStatus}
						type={"text"}
						label={"Checkpoint Status"}
						onChange={(e) => {
							onHandleCheckpointDetailChange(e.target.value, e.target.name);
						}}
						required
						error={error?.checkPoint?.checkpointStatus}
					/>
					<Input
						id={"holdDuration"}
						name={"holdDuration"}
						value={checkPoint.holdDuration}
						type={"number"}
						label={"Hold Duration (seconds)"}
						placeholder={"Enter Hold Duration."}
						step={1}
						onChange={(e) => {
							onHandleCheckpointDetailChange(Number(e.target.value) < 0 ? Number(0) : Number(e.target.value), e.target.name);
						}}
					/>
					<div style={{display : "flex", gap : '15px', height: "40px"}}>
						<Input
							id={"tripResetTimeLimit"}
							name={"tripResetTimeLimit"}
							value={checkPoint.tripResetTimeLimit}
							onChange={(e) => {
								onHandleCheckpointDetailChange(Number(e.target.value) < 0 ? Number(0) : Number(e.target.value), e.target.name);
							}}
							min={1}
							type={"number"}
							label={"Active Trip Override Threshold(min)"}
							placeholder={"Enter Active Trip Override Threshold."}
							step={1}
							error={error?.checkPoint?.tripResetTimeLimit}
							sx={{ width: "225px" }}
						/>
						<div style={{display : "flex", justifyContent : "center", alignItems: "center", marginLeft : "-15px"}}>
							<Tooltip title="Minimum time (Should be in minutes) after which a new entry event can terminate an ongoing trip for the same vehicle.">
								<InfoIcon sx={{ fill: "#ff7200" }} />
							</Tooltip>
						</div>
					</div>

					<div style={{display : "flex", gap : '15px'}}>
						<Input
							id={"gateOutOverrideMins"}
							name={"gateOutOverrideMins"}
							value={checkPoint.gateOutOverrideMins}
							onChange={(e) => {
								onHandleCheckpointDetailChange(Number(e.target.value) < 0 ? Number(0) : Number(e.target.value), e.target.name);
							}}
							min={1}
							type={"number"}
							label={"Gate Out Override Window (min)"}
							placeholder={"Enter Gate Out Override Window."}
							step={1}
							error={error?.checkPoint?.gateOutOverrideMins}
							sx={{ width: "225px" }}
						/>
						<div style={{display : "flex", justifyContent : "center", alignItems: "center", marginLeft : "-15px"}}>
							<Tooltip title="Re-scans at the Gate Out override checkpoint within this many minutes of the previous Gate Out are folded into that trip instead of creating a new one. 0 = disabled. Typical value: 20.">
								<InfoIcon sx={{ fill: "#ff7200" }} />
							</Tooltip>
						</div>
					</div>

					<div className="dropdown-div">
						<Dropdown
							id={"templateId"}
							name={"templateId"}
							value={
								templateList && templateList?.data && templateList?.data?.length > 0
									? templateList?.data?.filter((ele) => ele._id === checkPoint.templateId).map((ele) => ({ label: ele.name, value: ele._id }))[0]
									: null
							}
							options={templateList && templateList?.data && templateList?.data?.length > 0 ? templateList?.data?.map((ele) => ({ label: ele.name, value: ele._id })) : []}
							label={"Template Id"}
							onChange={(option, key) => onHandleCheckpointDetailChange(option?.value || "", key)}
							// required
							error={error?.checkPoint?.templateId}
						/>
					</div>
					<div className="dropdown-div">
						<Dropdown
							id={"entrySequence"}
							name={"entrySequence"}
							value={entrySequenceOpts.filter((_) => checkPoint.entrySequence?.find((v) => v._id == _.value))}
							options={entrySequenceOpts}
							multiple
							label="Entry Sequence"
							onChange={(option, key) => onHandleCheckpointDetailChange(option, key)}
						/>
					</div>
					<div className="dropdown-div">
						<Dropdown
							id={"postFunction"}
							name={"postFunction"}
							value={postFunctionOption.filter((ele) => ele.value === checkPoint.postFunction)[0] || null}
							options={postFunctionOption}
							label="Post Function"
							onChange={(option, key) => onHandleCheckpointDetailChange(option, key)}
						/>
					</div>
					<div className="checkpoint-detail-container">
						<Checkbox
							id="allowMultipleEntry"
							name="allowMultipleEntry"
							checked={checkPoint.allowMultipleEntry}
							label="Allow Multiple Entry"
							onChange={(e) => {
								onHandleCheckpointDetailChange(e.target.checked, e.target.name);
							}}
						/>
						<Checkbox
							id="validateCheckoutTime"
							name="validateCheckoutTime"
							checked={checkPoint.validateCheckoutTime}
							label="Validate Checkout Time"
							onChange={(e) => {
								onHandleCheckpointDetailChange(e.target.checked, e.target.name);
							}}
						/>

						<Checkbox
							id="entryPoint"
							name="entryPoint"
							checked={checkPoint.entryPoint}
							label="Entry Point"
							onChange={(e) => {
								onHandleCheckpointDetailChange(e.target.checked, e.target.name);
							}}
						/>
						{checkPoint.entryPoint && (
							<>
								<div className="dropdown-div">
									<Dropdown
										id="workFlowId"
										name="defaultWorkflowId"
										label="Default WorkFlow"
										onChange={(option, key) => onHandleCheckpointDetailChange(option?.value || "", key)}
										options={workflowListing}
										error={error?.checkPoint?.defaultWorkflowId}
										value={checkPoint?.defaultWorkflowId ? workflowListing.filter((ele) => ele.value === checkPoint.defaultWorkflowId)[0] : null}
									/>
								</div>
								<Checkbox
									id="createTripsThroughStrayFastags"
									name="createTripsThroughStrayFastags"
									checked={checkPoint.createTripsThroughStrayFastags}
									label="Create Trips Through Stray Fastags"
									onChange={(e) => {
										onHandleCheckpointDetailChange(e.target.checked, e.target.name);
									}}
								/>
							</>
						)}
						<Checkbox
							id="exitPoint"
							name="exitPoint"
							checked={checkPoint.exitPoint}
							label="Exit Point"
							onChange={(e) => {
								onHandleCheckpointDetailChange(e.target.checked, e.target.name);
							}}
						/>
						<Checkbox
							id="isBidirectional"
							name="isBidirectional"
							checked={checkPoint.isBidirectional}
							label="Is Bi-Directional?"
							onChange={(e) => {
								onHandleCheckpointDetailChange(e.target.checked, e.target.name);
							}}
							error={error?.isBidirectional}
						/>

						<Checkbox
							id="deallocateTag"
							name="deallocateTag"
							checked={checkPoint.deallocateTag}
							label="Deallocate Tag"
							onChange={(e) => {
								onHandleCheckpointDetailChange(e.target.checked, e.target.name);
							}}
						/>
						<Checkbox
							id="approvalRequired"
							name="approvalRequired"
							checked={checkPoint.approvalRequired}
							label="Approval Required"
							onChange={(e) => {
								onHandleCheckpointDetailChange(e.target.checked, e.target.name);
							}}
						/>

						<Checkbox
							id="isCustomEndPoint"
							name="isCustomEndPoint"
							checked={checkPoint.isCustomEndPoint}
							label="Add Custom API Endpoints"
							onChange={(e) => {
								onHandleCheckpointDetailChange(e.target.checked, e.target.name);
							}}
						/>
						<Checkbox
							id="customizeTripWorkflow"
							name="customizeTripWorkflow"
							checked={checkPoint.customizeTripWorkflow}
							label="Customize Trip Workflow"
							onChange={(e) => {
								onHandleCheckpointDetailChange(e.target.checked, e.target.name);
							}}
						/>
						{checkPoint.isCustomEndPoint == true && (
							<section className="checkpoint-detail-container">
								<div className="dropdown-div" style={{display:"flex", alignItems:"center", justifyContent:"center", gap:"2px"}}>
									<Dropdown
										id={"setupFunction"}
										name={"setupFunction"}
										value={checkPoint.setupFunction? defaultSetupFunctionOption.find(option => option.value === checkPoint.setupFunction): ""}
										options={defaultSetupFunctionOption}
										label={"Setup Function"}
										onChange={(option, key) => onHandleCheckpointDetailChange(option, key)}
									/>
									<Tooltip title="Choose an operation to run along the create API to manage custom data">
										<InfoIcon sx={{ fill: "#ff7200" }} />
									</Tooltip>
								</div>
								<Input
									id={"checkPoint_apiMethod"}
									name={"apiMethod"}
									value={checkPoint.apiMethod}
									type={"text"}
									label={"Create API Method"}
									onChange={(e) => {
										onHandleCheckpointDetailChange(e.target.value, e.target.name);
									}}
									required
									error={error?.checkPoint?.apiMethod}
								/>
								<div className="dropdown-div">
									<Dropdown
										id={"checkPoint_api"}
										name={"api"}
										value={
											ApiOption && ApiOption?.data && checkPoint.api
												? (ApiOption?.data.map((ele) => ({ label: ele.name, value: ele.endPoint })).filter((ele) => ele.value === checkPoint.api))[0]
												: null
										}
										options={ApiOption && ApiOption?.data ? ApiOption?.data.map((ele) => ({ label: ele.name, value: ele.endPoint })) : []}
										label={"Select Create API"}
										onChange={(option, key) => onHandleCheckpointDetailChange(option, key)}
										required
										error={error?.checkPoint?.api}
									/>
								</div>
								<Input
									id={"detailApiMethod"}
									name={"detailApiMethod"}
									value={checkPoint.detailApiMethod}
									type={"text"}
									label={"Detail API Method"}
									onChange={(e) => {
										onHandleCheckpointDetailChange(e.target.value, e.target.name);
									}}
									required
									error={error?.checkPoint?.detailApiMethod}
								/>
								<div className="dropdown-div">
									<Dropdown
										id={"detailApi"}
										name={"detailApi"}
										value={
											ApiOption && ApiOption?.data && checkPoint.detailApi
												? (ApiOption?.data.map((ele) => ({ label: ele.name, value: ele.endPoint })).filter((ele) => ele.value === checkPoint.detailApi))[0]
												: null
										}
										options={ApiOption && ApiOption?.data ? ApiOption?.data.map((ele) => ({ label: ele.name, value: ele.endPoint })) : []}
										label={"Select Detail API"}
										onChange={(option, key) => onHandleCheckpointDetailChange(option, key)}
										required
										error={error?.checkPoint?.detailApi}
									/>
								</div>
							</section>
						)}
					</div>
				</div>
				<AccordionWrapper title="Location detail" isOpenAcc={false}>
					{/* <div className="">
					<h5 className="checkpoint_subHeading">Location detail</h5>
				</div> */}
					<div className="checkpoint-detail-container">
						<Input
							id={"checkPoint_lat"}
							name={"latitude"}
							value={checkPoint.latitude}
							type={"text"}
							label={"Latitude"}
							onChange={(e) => {
								onHandleCheckpointDetailChange(e.target.value, e.target.name);
							}}
							// required
							error={error?.checkPoint?.latitude}
						/>
						<Input
							id={"checkPoint_log"}
							name={"longitude"}
							value={checkPoint.longitude}
							type={"text"}
							label={"Longitude"}
							onChange={(e) => {
								onHandleCheckpointDetailChange(e.target.value, e.target.name);
							}}
							// required
							error={error?.checkPoint?.longitude}
						/>
						{checkPoint.longitude && checkPoint.latitude && (
							<Button
								text="View Location"
								onClick={() => {
									handleViewMap();
								}}
								style={{ ...buttonClasses.lynkitOrangeEmpty, width: "10%" }}
							/>
						)}
					</div>
				</AccordionWrapper>
				<AccordionWrapper title="Listing Configuration" isOpenAcc={false}>
					{/* <div>
					<h5 className="checkpoint_subHeading">Listing Configuration</h5>
				</div> */}
					<div style={{ position: "relative" }}>
						{!addCustomListingConfig && (
							<div className="listingConfig-listing-container">
								{listingConfig.length > 0 &&
									listingConfig
										?.map((ele) => (ele.label && ele.order ? { order: ele.order, label: ele.label } : { order: "Missing", label: "No Listing Configration, Please Add one" }))
										.filter((ele) => ele !== null) // Filter out the null values
										.map((ele, index) => (
											<div key={index} className="listing-card-container">
												<div className="listing-card">
													<label>Order No.</label>
													<span>{ele.order}</span>
												</div>
												<div className="listing-card-filter">
													<span style={{ fontWeight: "600" }}>{ele.label}</span>
												</div>
											</div>
										))}
							</div>
						)}
						<div className="custom-listingConfig-listing-container">
							{!addCustomListingConfig ? (
								<span style={{ cursor: "pointer" }} onClick={() => setAddCustomListingConfig(!addCustomListingConfig)}>
									+ Add / Edit Custom Listing Configration
								</span>
							) : (
								<span className="close" onClick={() => setAddCustomListingConfig(!addCustomListingConfig)}>
									close
								</span>
							)}
						</div>
						{addCustomListingConfig && (
							<ListingConfigration listingConfig={listingConfig} setListingConfig={setListingConfig} productCategories={productCategories} products={products} suppliers={suppliers} />
						)}
					</div>
				</AccordionWrapper>

				<AccordionWrapper title="Approval Configuration" isOpenAcc={false}>
					{/* <div className="mt-2">
					<h5 className="checkpoint_subHeading">Approval Configuration</h5>
				</div> */}
					<div className="approval-container">
						<div>
							<Checkbox
								id="sendApproval"
								name="sendApproval"
								label="Send Approval"
								checked={approvalConfig.sendApproval}
								onChange={(e) => {
									onhandleConfigration(e.target.checked, e.target.name, "approvalConfig");
								}}
							/>
						</div>
						{approvalConfig.sendApproval && (
							<div>
								<Checkbox
									id="dependentApproval"
									name="dependentApproval"
									label="Dependent Approval"
									checked={approvalConfig.dependentApproval}
									onChange={(e) => {
										onhandleConfigration(e.target.checked, e.target.name, "approvalConfig");
									}}
								/>
							</div>
						)}
						{approvalConfig.sendApproval && !approvalConfig.dependentApproval && (
							<div className="dropdown-div">
								<Dropdown
									id={"approvalId"}
									name={"approvalId"}
									value={approvalConfig.approvalId ? approvalConfigOptions.find((ele) => ele.value == approvalConfig.approvalId) : null}
									options={approvalConfigOptions}
									label={"Select Configuration"}
									onChange={(option, key) => {
										onhandleConfigration(option?.value, key, "approvalConfig");
									}}
								/>
							</div>
						)}
						{approvalConfig.dependentApproval && (
							<div className="approvaldependancy-container border boder-rad-10p">
								{approvalConfig.approvaldependancy?.map(({ itemType, id }, i) => {
									const ItemOption =
										itemType === "productCategory"
											? productCategories.map((ele) => ({ label: ele.productCategory, value: ele._id }))
											: itemType === "product"
											? products.map((ele) => ({ label: ele.productName, value: ele._id }))
											: itemType === "supplier"
											? suppliers.map((ele) => ({ label: ele.supplierName, value: ele._id }))
											: [];
									return (
										<div key={`approval_${i}`} className="form-inputs">
											<div className="dropdown-div">
												<Dropdown
													id={"itemType"}
													name={"itemType"}
													value={itemType ? itemTypeOption2.filter((ele) => ele.value === itemType)[0] : null}
													options={itemTypeOption2}
													label={"Item Type"}
													onChange={(option, key) => onhandleApprovalConfigration(option, key, i)}
													required
													error={error.approvalConfig?.approvaldependancy?.length > 0 ? error.approvalConfig?.approvaldependancy[i]?.itemType : ""}
												/>
											</div>
											<div className="dropdown-div">
												<Dropdown
													id={"id"}
													name={"id"}
													value={ItemOption.length > 0 ? filterOption(ItemOption, id) : []}
													// value={ItemOption.length > 0 ? filterOption(ItemOption, id) : null}
													options={ItemOption}
													label={"Select Item"}
													multiple={true}
													onChange={(option, key) => onhandleApprovalConfigration(option, key, i)}
													required
													error={error.approvalConfig?.approvaldependancy?.length > 0 ? error.approvalConfig?.approvaldependancy[i]?.id : ""}
												/>
											</div>
											<div className="dropdown-div">
												<Dropdown
													id={"approvalId"}
													name={"approvalId"}
													value={
														approvalConfig?.approvaldependancy?.[i].approvalId
															? approvalConfigOptions.find((ele) => ele.value == approvalConfig?.approvaldependancy?.[i].approvalId)
															: ""
													}
													// value={
													// 	approvalConfig?.approvaldependancy?.[i].approvalId
													// 		? approvalConfigOptions.find((ele) => ele.value == approvalConfig?.approvaldependancy?.[i].approvalId)
													// 		: null
													// }
													options={approvalConfigOptions}
													label={"Select Configuration"}
													onChange={(option, key) => {
														onhandleApprovalConfigration(option?.value, key, i);
													}}
												/>
											</div>
											<AddRemove
												list={approvalConfig.approvaldependancy}
												filterMethod={(d) => d.itemType == ""}
												index={i}
												outerIndex={i}
												onAdd={addApprovalDependancyListing}
												onRemove={RemoveApprovalDependancyListing}
											/>
										</div>
									);
								})}
							</div>
						)}
					</div>
				</AccordionWrapper>
				<AccordionWrapper title="Device Scan Configuration" isOpenAcc={false}>
					<div className="deviceScannning-container">
						<div>
							<Checkbox
								id="deviceScannning"
								name="deviceScannning"
								checked={scanConfig.deviceScannning}
								label="Device Scanning"
								onChange={(e) => {
									onhandleConfigration(e.target.checked, e.target.name, "scanConfig");
								}}
							/>
						</div>
						{scanConfig.deviceScannning && (
							<>
								<div className="dropdown-div">
									<Dropdown
										id={"deviceId"}
										name={"deviceId"}
										value={
											scanConfig.deviceId
												? devices.length > 0 && devices.map((ele) => ({ label: ele.displayName, value: ele.imei })).filter((ele) => ele.value === scanConfig.deviceId)[0]
												: []
										}
										// value={
										// 	scanConfig.deviceId
										// 		? devices.length > 0 && devices.map((ele) => ({ label: ele.displayName, value: ele.imei })).filter((ele) => ele.value === scanConfig.deviceId)[0]
										// 		: null
										// }
										options={
											devices.length > 0
												? devices.filter((ele) => !["led", "speaker", "camera"].includes(ele.deviceType)).map((ele) => ({ label: ele.displayName, value: ele.imei }))
												: []
										}
										label={"Device Id"}
										multiple={false}
										onChange={(option, key) => onhandleConfigration(option?.value, key, "scanConfig")}
										// required
										// error={error?.scanConfig?.deviceId}
									/>
								</div>
								<div className="dropdown-div">
									<Dropdown
										id={"antennaId"}
										name={"antennaId"}
										value={scanConfig.antennaId && scanConfig.deviceId && devices.length > 0 ? antennaValue(scanConfig.antennaId, devices, scanConfig.deviceId) : []}
										// value={scanConfig.antennaId && scanConfig.deviceId && devices.length > 0 ? antennaValue(scanConfig.antennaId, devices, scanConfig.deviceId) : null}
										options={
											scanConfig.deviceId && devices.length > 0
												? devices
														.filter((ele) => ele.imei === scanConfig.deviceId)[0]
														?.antenna.filter((ele) => ele.status == "Active")
														.map((ele) => ({ label: `${ele.action} (${ele.antennanumber})`, value: ele.antennanumber })).length > 0
													? devices
															.filter((ele) => ele.imei === scanConfig.deviceId)[0]
															.antenna.filter((ele) => ele.status == "Active")
															.map((ele) => ({ label: `${ele.action} (${ele.antennanumber})`, value: ele.antennanumber }))
													: []
												: []
										}
										label={"Antenna Id"}
										multiple={false}
										onChange={(option, key) => onhandleConfigration(option?.value, key, "scanConfig")}
										// required
										// error={error?.scanConfig?.antennaId}
									/>
								</div>
								<div className="dropdown-div">
									<Dropdown
										id={"cameraId"}
										name={"cameraId"}
										value={cameraOptions?.filter((_) => cameraConfig?.find((_c) => _c == _.value)) || []}
										options={cameraOptions}
										label="Camera Id"
										multiple
										onChange={(selectedOptions) => {
											const selectedValues = selectedOptions ? selectedOptions.map((opt) => opt.value) : [];
											setCameraConfig(selectedValues);
										}}
									/>
								</div>
							</>
						)}
					</div>
				</AccordionWrapper>
				{assetAddPerm || assetScanPerm ? (
					<>
						<div className="mt-2">
							<h5 className="checkpoint_subHeading">Asset Configuration</h5>
						</div>
						<div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
							{assetAddPerm ? (
								<div>
									<Checkbox
										id="assetAddPerm"
										name="assetAdd"
										checked={assetConfig.assetAdd}
										label="Map Assets"
										onChange={(e) => {
											onhandleConfigration(e.target.checked, e.target.name, "assetConfig");
										}}
									/>
								</div>
							) : null}
							{assetScanPerm ? (
								<div>
									<Checkbox
										id="assetScanPerm"
										name="assetScan"
										checked={assetConfig.assetScan}
										label="Scan Assets"
										onChange={(e) => {
											onhandleConfigration(e.target.checked, e.target.name, "assetConfig");
										}}
									/>
								</div>
							) : null}
						</div>
					</>
				) : null}
				<AccordionWrapper title="Accessory Configuration" isOpenAcc={false}>
					{/* <div className="mt-2">
					<h5 className="checkpoint_subHeading">Accessory Configuration</h5>
				</div> */}
					<div className="LED-container p-2 border boder-rad-10p">
						<div className="title">Trigger LED</div>
						<Checkbox
							id="triggerLED"
							name="triggerLED"
							checked={LEDConfig?.isActive}
							label="Is Active?"
							onChange={(e) => {
								setLEDConfig((prev) => ({ ...prev, ["isActive"]: e.target.checked }));
							}}
						/>
						<div className="dropdown-div">
							<Dropdown
								id={"ledId"}
								name={"ledId"}
								value={
									LEDConfig?.ledDetails?.ledId
										? devices.length > 0 && devices.map((ele) => ({ label: ele.displayName, value: ele.imei })).filter((ele) => ele.value === LEDConfig.ledDetails.ledId)[0]
										: []
								}
								// value={
								// 	LEDConfig?.ledDetails?.ledId
								// 		? devices.length > 0 && devices.map((ele) => ({ label: ele.displayName, value: ele.imei })).filter((ele) => ele.value === LEDConfig.ledDetails.ledId)[0]
								// 		: null
								// }
								options={devices.length > 0 ? devices.filter((ele) => ele.deviceType === "led").map((ele) => ({ label: ele.displayName, value: ele.imei, data: ele })) : []}
								label={"LED Device Id"}
								multiple={false}
								onChange={(option, key) => {
									setLEDConfig((prev) => ({
										...prev,
										ledDetails: {
											...prev.ledDetails,
											ledId: option?.value || "",
											deviceSubType: option?.data?.deviceSubType || "",
										},
									}));
								}}
								required
								error={error?.ledConfig?.ledId}
							/>
						</div>
						<div className="p-2 border boder-rad-10p" style={{ width: "100%" }}>
							<div className="title" style={{ fontWeight: 600 }}>
								Event types for LED
							</div>
							{LEDConfig?.ledDetails?.eventTypes?.map((eventType, index) => {
								const selectedTypes = LEDConfig.ledDetails.eventTypes.map((et, idx) => (idx === index ? null : et.type)).filter(Boolean);
								// Filter available options in type dropdown
								const availableOptions = DEFAULT_EVENT_TPYE_OPTION.filter((option) => !selectedTypes.includes(option.value));
								// Check if we should disable AddRemove
								const allTypesUsed = LEDConfig.ledDetails.eventTypes.length === DEFAULT_EVENT_TPYE_OPTION.length;
								const isLastItem = index === LEDConfig.ledDetails.eventTypes.length - 1;
								return (
									<div key={index} className="LED-container mb-0 mt-2">
										<div className="LED-container p-2 border boder-rad-10p mt-2" style={{ display: "flex", alignItems: "center", gap: "0.5rem", flexWrap: "wrap", width: "90%" }}>
											<div className="dropdown-div " style={{ flex: "0 0 auto", maxWidth: "180px" }}>
												<Dropdown
													id={`type-${index}`}
													name={"type"}
													label="Type"
													value={DEFAULT_EVENT_TPYE_OPTION.find((opt) => opt.value === eventType.type) || null}
													options={DEFAULT_EVENT_TPYE_OPTION}
													onChange={(option) => {
														setLEDConfig((prev) => {
															const newConfig = JSON.parse(JSON.stringify(prev));
															newConfig.ledDetails.eventTypes[index].type = option?.value || "";
															return newConfig;
														});
													}}
													error={error?.ledConfig?.eventTypes?.[index]?.type}
												/>
											</div>

											{LEDConfig?.ledDetails?.deviceSubType === "TENLINE" ? (
												<div className="genDiv" style={{ flex: "1 1 auto", display: "flex", alignItems: "center", gap: "1rem", flexWrap: "nowrap" }}>
													<div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
														<Input
															label="Generator Function"
															placeholder="Generator Function"
															name="generatorFunction"
															value={eventType.generatorFunction || ""}
															onChange={(e) => {
																setLEDConfig((prev) => {
																	const newConfig = JSON.parse(JSON.stringify(prev));
																	newConfig.ledDetails.eventTypes[index].generatorFunction = e.target.value;
																	return newConfig;
																});
															}}
														/>
													</div>
													<div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
														{eventType.parameters?.map((param, paramIndex) => (
															<div className="paraDiv" key={paramIndex} style={{ display: "flex", alignItems: "center", flexWrap: "nowrap", gap: "0.5rem" }}>
																<Input
																	label="Parameters"
																	placeholder="Enter Parameters"
																	name="parameters"
																	value={param}
																	onChange={(e) => {
																		setLEDConfig((prev) => {
																			const newConfig = JSON.parse(JSON.stringify(prev));
																			newConfig.ledDetails.eventTypes[index].parameters[paramIndex] = e.target.value;
																			return newConfig;
																		});
																	}}
																/>
																<AddRemove
																	list={eventType.parameters}
																	filterMethod={(param) => param === ""}
																	index={paramIndex}
																	outerIndex={paramIndex}
																	onAdd={() => {
																		setLEDConfig((prev) => {
																			const newConfig = JSON.parse(JSON.stringify(prev));
																			newConfig.ledDetails.eventTypes[index].parameters.push("");
																			return newConfig;
																		});
																	}}
																	onRemove={() => {
																		setLEDConfig((prev) => {
																			const newConfig = JSON.parse(JSON.stringify(prev));
																			newConfig.ledDetails.eventTypes[index].parameters.splice(paramIndex, 1);
																			return newConfig;
																		});
																	}}
																/>
															</div>
														))}
													</div>
												</div>
											) : (
												<>
													<Input
														type="number"
														id={"order"}
														name={`order`}
														value={eventType.order}
														label="Order"
														onChange={(e) => {
															setLEDConfig((prev) => {
																const newConfig = JSON.parse(JSON.stringify(prev));
																newConfig.ledDetails.eventTypes[index].order = Number(e.target.value);
																return newConfig;
															});
														}}
													/>
													<Input
														id={`lineOne-${index}`}
														name={`lineOne-${index}`}
														value={eventType.lineOne || ""}
														label="Line One"
														onChange={(e) => {
															setLEDConfig((prev) => {
																const lineOneMatches = findIndexForVariableList(e.target.value);
																const lineTwoMatches = findIndexForVariableList(prev.ledDetails.eventTypes[index].lineTwo);

																// Combine and deduplicate all placeholders
																const allPlaceholders = [...lineOneMatches, ...lineTwoMatches].filter(
																	(item, i, arr) => arr.findIndex((t) => t.index === item.index) === i
																);

																// Create or update variableList array
																const newVarList = [...(prev.ledDetails.eventTypes[index].variableList || [])];
																allPlaceholders.forEach((ph) => {
																	if (newVarList[ph.index] === undefined) {
																		newVarList[ph.index] = "";
																	}
																});

																const updatedEventTypes = [...prev.ledDetails.eventTypes];
																updatedEventTypes[index] = {
																	...updatedEventTypes[index],
																	lineOne: e.target.value,
																	variableList: newVarList,
																};

																return {
																	...prev,
																	ledDetails: {
																		...prev.ledDetails,
																		eventTypes: updatedEventTypes,
																	},
																};
															});
														}}
														required
														error={error?.ledConfig?.eventTypes?.[index]?.lineOne}
													/>
													<Tooltip title="Use {0} for Dynamic data. Count will be increased for multi dynamic data">
														<InfoIcon sx={{ fill: "#ff7200" }} />
													</Tooltip>

													<Input
														id={`lineTwo-${index}`}
														name={`lineTwo-${index}`}
														value={eventType.lineTwo || ""}
														label="Line Two"
														onChange={(e) => {
															setLEDConfig((prev) => {
																const lineOneMatches = findIndexForVariableList(prev.ledDetails.eventTypes[index].lineOne);
																const lineTwoMatches = findIndexForVariableList(e.target.value);

																const allPlaceholders = [...lineOneMatches, ...lineTwoMatches].filter(
																	(item, i, arr) => arr.findIndex((t) => t.index === item.index) === i
																);

																const newVarList = [...(prev.ledDetails.eventTypes[index].variableList || [])];
																allPlaceholders.forEach((ph) => {
																	if (newVarList[ph.index] === undefined) {
																		newVarList[ph.index] = "";
																	}
																});

																const updatedEventTypes = [...prev.ledDetails.eventTypes];
																updatedEventTypes[index] = {
																	...updatedEventTypes[index],
																	lineTwo: e.target.value,
																	variableList: newVarList,
																};

																return {
																	...prev,
																	ledDetails: {
																		...prev.ledDetails,
																		eventTypes: updatedEventTypes,
																	},
																};
															});
														}}
														required
														error={error?.ledConfig?.eventTypes?.[index]?.lineTwo}
													/>
													<Input
														type="number"
														id={"duration"}
														name={`duration`}
														value={eventType.duration / 1000}
														label="Next command delay (sec)"
														onChange={(e) => {
															setLEDConfig((prev) => {
																const newConfig = JSON.parse(JSON.stringify(prev));
																newConfig.ledDetails.eventTypes[index].duration = Number(e.target.value) * 1000;
																return newConfig;
															});
														}}
													/>
												</>
											)}

											{/* {(eventType.lineOne && findIndexForVariableList(eventType.lineOne).length > 0) ||
										(eventType.lineTwo && findIndexForVariableList(eventType.lineTwo).length > 0) ? (
											<div className="LED-sub-container">
												<span className="div-label">Variable Mapping</span>
												<div style={{ maxHeight: "131px", overflow: "auto", paddingTop: "5px" }}>
													
													{eventType.lineOne &&
														findIndexForVariableList(eventType.lineOne).map((ele, varIndex) => (
															<div key={`line1-${index}-${varIndex}`} className="listing-card-container">
																<div className="listing-card">
																	<label>Line One </label>
																	<span>{ele.element}</span>
																</div>
																<div className="listing-card-filter">
																	<div className="dropdown-div">
																		<Dropdown
																			id={`variableList-line1-${index}-${varIndex}`}
																			name={`variableList`}
																			value={findVariableListing(varIndex, eventType.variableList || [], variableListing)}
																			options={variableListing || []}
																			label={"Variable List"}
																			multiple={false}
																			onChange={(option) => {
																				setLEDConfig((prev) => {
																					const updatedEventTypes = [...prev.ledDetails.eventTypes];
																					updatedEventTypes[index].variableList.splice(varIndex, 1, option?.value || "");
																					return {
																						...prev,
																						ledDetails: {
																							...prev.ledDetails,
																							eventTypes: updatedEventTypes,
																						},
																					};
																				});
																			}}
																			required
																			getOptionDisabled={(option) => {
																				return eventType.variableList?.length > 0
																					? eventType.variableList.some((filterItem) => filterItem === option.value)
																					: false;
																			}}
																			error={error?.ledConfig?.eventTypes?.[index]?.variableList?.[varIndex]?.toString() ?? false}
																		/>
																	</div>
																</div>
															</div>
														))}

													
													{eventType.lineTwo &&
														findIndexForVariableList(eventType.lineTwo).map((ele, varIndex) => {
															const lineTwoVarIndex = (eventType.lineOne ? findIndexForVariableList(eventType.lineOne).length : 0) + varIndex;
															return (
																<div key={`line2-${index}-${lineTwoVarIndex}`} className="listing-card-container">
																	<div className="listing-card">
																		<label>Line Two</label>
																		<span>{ele.element}</span>
																	</div>
																	<div className="listing-card-filter">
																		<div className="dropdown-div">
																			<Dropdown
																				id={`variableList-line2-${index}-${lineTwoVarIndex}`}
																				name={`variableList`}
																				value={findVariableListing(lineTwoVarIndex, eventType.variableList || [], variableListing)}
																				options={variableListing || []}
																				label={"Variable List"}
																				multiple={false}
																				onChange={(option) => {
																					setLEDConfig((prev) => {
																						const updatedEventTypes = [...prev.ledDetails.eventTypes];
																						updatedEventTypes[index].variableList.splice(lineTwoVarIndex, 1, option?.value || "");
																						return {
																							...prev,
																							ledDetails: {
																								...prev.ledDetails,
																								eventTypes: updatedEventTypes,
																							},
																						};
																					});
																				}}
																				required
																				getOptionDisabled={(option) => {
																					return eventType.variableList?.length > 0
																						? eventType.variableList.some((filterItem) => filterItem === option.value)
																						: false;
																				}}
																				error={error?.ledConfig?.eventTypes?.[index]?.variableList?.[lineTwoVarIndex]?.toString() ?? false}
																			/>
																		</div>
																	</div>
																</div>
															);
														})}
												</div>
											</div>
										) : null} */}

											{(eventType.lineOne || eventType.lineTwo) && LEDConfig?.ledDetails?.deviceSubType !== "TENLINE" && (
												<div className="LED-sub-container" style={{ marginTop: "2px" }}>
													<span className="div-label">Variable Mapping</span>
													<div style={{ maxHeight: "131px", overflow: "auto", paddingTop: "5px" }}>
														{/* Get all unique placeholders from both lines */}
														{[...findIndexForVariableList(eventType.lineOne), ...findIndexForVariableList(eventType.lineTwo)]
															.filter((item, index, self) => index === self.findIndex((t) => t.index === item.index))
															.map((ele, varIndex) => (
																<div key={`var-${index}-${varIndex}`} className="listing-card-container">
																	<div className="listing-card">
																		<label>#Index</label>
																		<span>{ele.element}</span>
																	</div>
																	<div className="listing-card-filter">
																		<div className="dropdown-div">
																			<Dropdown
																				id={`variableList-${index}-${varIndex}`}
																				name={`variableList`}
																				value={findVariableListing(varIndex, eventType.variableList || [], variableListing)}
																				options={variableListing || []}
																				label={"Variable List"}
																				multiple={false}
																				onChange={(option) => {
																					setLEDConfig((prev) => {
																						const updatedEventTypes = [...prev.ledDetails.eventTypes];
																						updatedEventTypes[index].variableList[ele.index] = option?.value || "";
																						return {
																							...prev,
																							ledDetails: {
																								...prev.ledDetails,
																								eventTypes: updatedEventTypes,
																							},
																						};
																					});
																				}}
																				required
																				getOptionDisabled={(option) => {
																					return eventType.variableList?.some((filterItem) => filterItem === option.value);
																				}}
																				error={error?.ledConfig?.eventTypes?.[index]?.variableList?.[ele.index]?.toString() ?? false}
																			/>
																		</div>
																	</div>
																</div>
															))}
													</div>
												</div>
											)}
										</div>
										<AddRemove
											list={LEDConfig?.ledDetails?.eventTypes || []}
											filterMethod={(item) => !item.type}
											index={index}
											outerIndex={index}
											onAdd={() => {
												// if (!allTypesUsed) {
												setLEDConfig((prev) => {
													const newConfig = JSON.parse(JSON.stringify(prev));
													newConfig.ledDetails.eventTypes.push({
														type: "",
														...(prev.ledDetails.deviceSubType === "TENLINE"
															? {
																	generatorFunction: "",
																	parameters: [""],
															  }
															: {
																	lineOne: "",
																	lineTwo: "",
																	variableList: [],
																	order: null,
																	duration: 0,
															  }),
													});
													return newConfig;
												});
												// }
											}}
											onRemove={(i) => {
												setLEDConfig((prev) => ({
													...prev,
													ledDetails: {
														...prev.ledDetails,
														eventTypes: prev.ledDetails.eventTypes.filter((_, idx) => idx !== i),
													},
												}));
											}}
										/>
									</div>
								);
							})}
						</div>
					</div>

					{/* SPEAKER SECTION */}
					<div className="LED-container p-2 border boder-rad-10p mt-2">
						<div className="title">Trigger Speaker</div>
						<Checkbox
							id="triggerSpeaker"
							name="isActive"
							checked={speakerConfig?.isActive}
							label="Is Active?"
							onChange={(e) => {
								setSpeakerConfig((prev) => ({ ...prev, ["isActive"]: e.target.checked }));
							}}
						/>
						<div className="dropdown-div">
							<Dropdown
								id={"speakerId"}
								name={"speakerId"}
								value={
									speakerConfig?.speakerDetails?.speakerId
										? devices.length > 0 &&
										  devices.map((ele) => ({ label: ele.displayName, value: ele.imei })).filter((ele) => ele.value === speakerConfig?.speakerDetails?.speakerId)[0]
										: []
								}
								// value={
								// 	speakerConfig?.speakerDetails?.speakerId
								// 		? devices.length > 0 &&
								// 		  devices.map((ele) => ({ label: ele.displayName, value: ele.imei })).filter((ele) => ele.value === speakerConfig?.speakerDetails?.speakerId)[0]
								// 		: null
								// }
								options={devices.length > 0 ? devices.filter((ele) => ele.deviceType === "speaker").map((ele) => ({ label: ele.displayName, value: ele.imei })) : []}
								label={"Speaker Device Id"}
								multiple={false}
								onChange={(option, key) =>
									setSpeakerConfig((prev) => ({
										...prev,
										speakerDetails: {
											...prev.speakerDetails,
											speakerId: option?.value || "",
										},
									}))
								}
								required
								error={error?.speakerConfig?.speakerId}
							/>
						</div>

						<div className="p-2 border boder-rad-10p" style={{ width: "100%" }}>
							<div className="title" style={{ fontWeight: 600 }}>
								Event types for speaker
							</div>
							{speakerConfig?.speakerDetails?.eventTypes?.map((eventType, index) => {
								const selectedTypes = speakerConfig.speakerDetails.eventTypes.map((et, idx) => (idx === index ? null : et.type)).filter(Boolean);

								// Filter available options
								const availableOptions = DEFAULT_EVENT_TPYE_OPTION.filter((option) => !selectedTypes.includes(option.value));

								// Check if we should disable AddRemove
								const allTypesUsed = speakerConfig.speakerDetails.eventTypes.length === DEFAULT_EVENT_TPYE_OPTION.length;
								const isLastItem = index === speakerConfig.speakerDetails.eventTypes.length - 1;
								return (
									<div key={index} className="LED-container mb-0 mt-2">
										<div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
											<div className="dropdown-div" style={{ flex: 1 }}>
												<Dropdown
													id={`type-${index}`}
													name={"type"}
													label="Type"
													value={availableOptions.find((opt) => opt.value === eventType.type) || null}
													options={availableOptions}
													onChange={(option) => {
														setSpeakerConfig((prev) => {
															const newConfig = JSON.parse(JSON.stringify(prev));
															newConfig.speakerDetails.eventTypes[index].type = option?.value || "";
															return newConfig;
														});
													}}
													error={error?.speakerConfig?.eventTypes?.[index]?.type}
												/>
											</div>

											<div style={{ display: "flex", alignItems: "center", gap: "0.1rem" }}>
												<Input
													id={`lineOne-${index}`}
													name={`lineOne-${index}`}
													value={eventType.lineOne || ""}
													label="Line One"
													onChange={(e) => {
														setSpeakerConfig((prev) => {
															const matches = e.target.value.match(/\{(\d+)+\}/g);
															let varList = [];
															if (matches && matches.length) {
																varList = Array(matches.length).fill("");
															}

															const updatedEventTypes = [...prev.speakerDetails.eventTypes];
															updatedEventTypes[index] = {
																...updatedEventTypes[index],
																lineOne: e.target.value,
																variableList: varList,
															};

															return {
																...prev,
																speakerDetails: {
																	...prev.speakerDetails,
																	eventTypes: updatedEventTypes,
																},
															};
														});
													}}
													required
													error={error?.speakerConfig?.eventTypes?.[index]?.lineOne}
												/>
												<Tooltip title="Use {0} for Dynamic data. Count will be increased for multi dynamic data">
													<InfoIcon sx={{ fill: "#ff7200" }} />
												</Tooltip>
											</div>
										</div>

										{eventType.lineOne && findIndexForVariableList(eventType.lineOne).length > 0 && (
											<div className="LED-sub-container">
												<span className="div-label">Line One</span>
												<div style={{ maxHeight: "131px", overflow: "auto", paddingTop: "5px" }}>
													{findIndexForVariableList(eventType.lineOne).map((ele, varIndex) => (
														<div key={`${index}-${varIndex}`} className="listing-card-container">
															<div className="listing-card">
																<label>#Index</label>
																<span>{ele.element}</span>
															</div>
															<div className="listing-card-filter">
																<div className="dropdown-div">
																	<Dropdown
																		id={`variableList-${index}-${varIndex}`}
																		name={`variableList`}
																		value={findVariableListing(varIndex, eventType.variableList || [], variableListing)}
																		options={variableListing || []}
																		label={"Variable List"}
																		multiple={false}
																		onChange={(option) => {
																			setSpeakerConfig((prev) => {
																				const updatedEventTypes = [...prev.speakerDetails.eventTypes];
																				updatedEventTypes[index].variableList.splice(varIndex, 1, option?.value || "");

																				return {
																					...prev,
																					speakerDetails: {
																						...prev.speakerDetails,
																						eventTypes: updatedEventTypes,
																					},
																				};
																			});
																		}}
																		required
																		getOptionDisabled={(option) => {
																			return eventType.variableList?.length > 0
																				? eventType.variableList.some((filterItem) => filterItem === option.value)
																				: false;
																		}}
																		error={error?.speakerConfig?.eventTypes?.[index]?.variableList?.[varIndex]?.toString() ?? false}
																	/>
																</div>
															</div>
														</div>
													))}
												</div>
											</div>
										)}
										<AddRemove
											list={speakerConfig?.speakerDetails?.eventTypes || []}
											filterMethod={(item) => !item.type || allTypesUsed}
											index={index}
											outerIndex={index}
											onAdd={() => {
												if (!allTypesUsed) {
													setSpeakerConfig((prev) => {
														const newConfig = JSON.parse(JSON.stringify(prev));
														newConfig.speakerDetails.eventTypes.push({
															type: "",
															lineOne: "",
															variableList: [],
														});
														return newConfig;
													});
												}
											}}
											onRemove={(i) => {
												setSpeakerConfig((prev) => ({
													...prev,
													speakerDetails: {
														...prev.speakerDetails,
														eventTypes: prev.speakerDetails.eventTypes.filter((_, idx) => idx !== i),
													},
												}));
											}}
										/>
									</div>
								);
							})}
						</div>
					</div>

					<div className="mt-4">
						<DndProvider backend={HTML5Backend}>
							<div>
								{displayAccessories.map(({ accessoriesName, accessoriesData }, index) => {
									if (!["triggerLED", "triggerSpeaker"].includes(accessoriesName)) {
										if (!accessoriesData.eventTypes || !Array.isArray(accessoriesData.eventTypes)) {
											accessoriesData.eventTypes = [{ type: "", duration: 0 }];
										}
										const { isActive, value, duration } = accessoriesData;
										if (accessoriesName && !gpoOptions.some((option) => option.value === accessoriesName || option.label === accessoriesName)) {
											gpoOptions.push({ label: accessoriesName, value: accessoriesName });
										}
										return (
											<DraggableAccessory key={index} id={accessoriesName} index={index} moveItem={moveItem}>
												<div className="LED-container p-2 border boder-rad-10p mt-2 mb-0">
													<div style={{ width: "220px" }}>
														<Dropdown
															id="accessoryName"
															name={"accessoryName"}
															label="Accessory Name"
															placeholder="Accessory Name"
															value={
																accessories[index]?.accessoriesName
																	? gpoOptions.find(
																			(option) => option.value === accessories[index]?.accessoriesName || option.label === accessories[index]?.accessoriesName
																	  ) || null
																	: null
															}
															options={gpoOptions}
															onChange={(selected) => {
																const updated = [...displayAccessories];
																updated[index].accessoriesName = selected?.value || "";
																setAccessories(updated);
															}}
															required
															error={error?.accessories?.[index]?.accessoriesName}
														/>
													</div>
													<Checkbox
														id="isActive"
														name="isActive"
														checked={isActive}
														label="Is Active?"
														onChange={(e) => {
															const updated = [...displayAccessories];
															updated[index].accessoriesData.isActive = e.target.checked;
															setAccessories(updated);
														}}
													/>

													{/* <Input
															id="value"
															name="value"
															value={value}
															label="Value"
															onChange={(e) => {
																const updated = [...accessories];
																updated[index].accessoriesData.value = e.target.value;
																setAccessories(updated);
															}}
														/> */}
													<div style={{ display: "flex", flexDirection: "column" }}>
														{accessoriesData.eventTypes.map((eventType, eventIndex) => {
															// const selectedTypes = accessoriesData.eventTypes.map((et, idx) => (idx === eventIndex ? null : et.type)).filter(Boolean);
															const selectedTypes = accessoriesData.eventTypes.filter((_, idx) => idx !== eventIndex).map((et) => et.type);

															const availableOptions = DEFAULT_EVENT_TPYE_OPTION.filter((option) => !selectedTypes.includes(option.value));
															const isLastItem = eventIndex === accessoriesData.eventTypes.length - 1;
															const canAddMore = accessoriesData.eventTypes.length < DEFAULT_EVENT_TPYE_OPTION.length;
															const filterMethod = (item) => {
																// Only prevent adding if we have all types or current item is invalid
																return !canAddMore || !item.type;
															};
															return (
																<div key={eventIndex} style={{ display: "flex", alignItems: "center", gap: "1rem", marginTop: "0.5rem" }}>
																	<div className="dropdown-div" style={{ flex: 1 }}>
																		<Dropdown
																			id={`type-${index}-${eventIndex}`}
																			name={"type"}
																			label="Type"
																			value={availableOptions.find((opt) => opt.value === eventType.type) || null}
																			options={availableOptions}
																			onChange={(option) => {
																				const updated = [...displayAccessories];
																				updated[index] = {
																					...updated[index],
																					accessoriesData: {
																						...updated[index].accessoriesData,
																						eventTypes: updated[index].accessoriesData.eventTypes.map((et, idx) =>
																							idx === eventIndex ? { ...et, type: option?.value || "" } : et
																						),
																					},
																				};
																				setAccessories(updated);
																			}}
																			error={error?.accessories?.[index]?.eventTypes?.[eventIndex]?.type}
																			required
																		/>
																	</div>

																	<Input
																		type="number"
																		id={`duration-${index}-${eventIndex}`}
																		name={`duration`}
																		value={eventType.duration / 1000}
																		label="Next command delay (sec)"
																		onChange={(e) => {
																			const updated = [...displayAccessories];
																			updated[index] = {
																				...updated[index],
																				accessoriesData: {
																					...updated[index].accessoriesData,
																					eventTypes: updated[index].accessoriesData.eventTypes.map((et, idx) =>
																						idx === eventIndex ? { ...et, duration: Number(e.target.value) * 1000 } : et
																					),
																				},
																			};
																			setAccessories(updated);
																		}}
																	/>
																	<div style={{ width: "50px" }}>
																		<AddRemove
																			list={accessoriesData.eventTypes}
																			filterMethod={filterMethod}
																			index={eventIndex}
																			outerIndex={isLastItem ? accessoriesData.eventTypes.length - 1 : eventIndex}
																			onAdd={() => {
																				if (accessoriesData.eventTypes.length < DEFAULT_EVENT_TPYE_OPTION.length) {
																					const updated = [...displayAccessories];
																					// Create a new array for eventTypes to ensure mutability
																					updated[index].accessoriesData = {
																						...updated[index].accessoriesData,
																						eventTypes: [...updated[index].accessoriesData.eventTypes, { type: "", duration: 0 }],
																					};
																					setAccessories(updated);
																				}
																			}}
																			onRemove={(i) => {
																				const updated = [...displayAccessories];
																				updated[index].accessoriesData = {
																					...updated[index].accessoriesData,
																					eventTypes: updated[index].accessoriesData.eventTypes.filter((_, idx) => idx !== i),
																				};
																				setAccessories(updated);
																			}}
																		/>
																	</div>
																</div>
															);
														})}
													</div>
												</div>
												<AddRemove
													// list={accessories}
													list={displayAccessories.filter((item) => !["triggerLED", "triggerSpeaker"].includes(item.accessoriesName))}
													filterMethod={() => false}
													index={displayAccessories.filter((item) => !["triggerLED", "triggerSpeaker"].includes(item.accessoriesName)).findIndex((_, i) => displayAccessories.indexOf(displayAccessories.filter((item) => !["triggerLED", "triggerSpeaker"].includes(item.accessoriesName))[i]) === index)}
													outerIndex={displayAccessories.filter((item) => !["triggerLED", "triggerSpeaker"].includes(item.accessoriesName)).length - 1}
													onAdd={() => {
														setAccessories((prev) => {
															const newItem = {
																accessoriesName: "",
																accessoriesData: {
																	isActive: false,
																	value: "",
																	duration: 0,
																	order: prev.length + 1,
																},
															};
															return [...prev, newItem].filter((item) => !["triggerLED", "triggerSpeaker"].includes(item.accessoriesName));
														});
													}}
													onRemove={(i) => {
														setAccessories((prev) =>
															prev
																.filter((_, idx) => idx !== i)
																.map((item, idx) => ({
																	...item,
																	accessoriesData: {
																		...item.accessoriesData,
																		order: idx + 1,
																	},
																}))
														);
													}}
												/>
											</DraggableAccessory>
										);
									}
								})}
							</div>
						</DndProvider>
					</div>
				</AccordionWrapper>

				<AccordionWrapper title="Checkout Configuration" isOpenAcc={false}>
					{/* <div className="mt-2">
					<h5 className="checkpoint_subHeading">Checkout Configuration</h5>
				</div> */}
					<div className="checkoutConfig-container">
						{scanConfig.deviceScannning && (
							<div>
								<Checkbox
									id="checkoutWhenOutOfRange"
									name="checkoutWhenOutOfRange"
									checked={checkoutConfig.checkoutWhenOutOfRange}
									label="Checkout when out of Device Range"
									onChange={(e) => {
										onhandleConfigration(e.target.checked, e.target.name, "checkpointConfig");
									}}
								/>
							</div>
						)}
						<div>
							<Checkbox
								id="checkoutOnSubmit"
								name="checkoutOnSubmit"
								checked={checkoutConfig.checkoutOnSubmit}
								label="Checkout on Submit"
								onChange={(e) => {
									onhandleConfigration(e.target.checked, e.target.name, "checkpointConfig");
								}}
							/>
						</div>
						<div>
							<Checkbox
								id="autoCheckout"
								name="autoCheckout"
								checked={checkoutConfig.autoCheckout}
								label="Auto Checkout"
								onChange={(e) => {
									onhandleConfigration(e.target.checked, e.target.name, "checkpointConfig");
								}}
							/>
						</div>
						<div>
							<Checkbox
								id="checkoutOnApproval"
								name="checkoutOnApproval"
								checked={checkoutConfig.checkoutOnApproval}
								label="Checkout on Approval"
								onChange={(e) => {
									onhandleConfigration(e.target.checked, e.target.name, "checkpointConfig");
								}}
							/>
						</div>
						<div>
							<Checkbox
								id="hideInTime"
								name="hideInTime"
								checked={checkoutConfig.hideInTime}
								label="Hide In Time"
								onChange={(e) => {
									onhandleConfigration(e.target.checked, e.target.name, "checkpointConfig");
								}}
							/>
						</div>
						<div>
							<Checkbox
								id="hideOutTime"
								name="hideOutTime"
								checked={checkoutConfig.hideOutTime}
								label="Hide Out Time"
								onChange={(e) => {
									onhandleConfigration(e.target.checked, e.target.name, "checkpointConfig");
								}}
							/>
						</div>
						<div>
							<Input
								id={"checkoutHoldDuration"}
								name={"checkoutHoldDuration"}
								value={checkoutConfig.checkoutHoldDuration}
								type={"number"}
								label={"Checkout HoldDuration (Seconds)"}
								onChange={(e) => {
									onhandleConfigration(e.target.value, e.target.name, "checkpointConfig");
								}}
								min="0"
								// required
								error={error?.checkoutConfig?.checkoutHoldDuration}
							/>
						</div>
						<div>
							<Input
								id={"inTimeLabel"}
								name={"inTimeLabel"}
								value={checkoutConfig.inTimeLabel}
								type={"text"}
								label={"In Time label"}
								onChange={(e) => {
									onhandleConfigration(e.target.value, e.target.name, "checkpointConfig");
								}}
								// required
								error={error?.checkoutConfig?.inTimeLabel}
							/>
						</div>
						<div>
							<Input
								id={"outTimeLabel"}
								name={"outTimeLabel"}
								value={checkoutConfig.outTimeLabel}
								type={"text"}
								label={"Out Time label"}
								onChange={(e) => {
									onhandleConfigration(e.target.value, e.target.name, "checkpointConfig");
								}}
								// required
								error={error?.checkoutConfig?.outTimeLabel}
							/>
						</div>
						<div className="dropdown-div">
							<Dropdown
								id={"checkoutConfig_templateId"}
								name={"templateId"}
								value={
									templateList && templateList?.data && templateList?.data?.length > 0
										? templateList?.data?.filter((ele) => ele._id === checkoutConfig.templateId).map((ele) => ({ label: ele.name, value: ele._id }))[0]
										: null
								}
								options={templateList && templateList?.data && templateList?.data?.length > 0 ? templateList?.data?.map((ele) => ({ label: ele.name, value: ele._id })) : []}
								label={"Checkout template Id"}
								onChange={(option, key) => onhandleConfigration(option?.value, key, "checkpointConfig")}
								// required
								error={error?.checkoutConfig?.templateId}
							/>
						</div>
						{/* <Input
						id={"checkoutConfig_templateId"}
						name={"templateId"}
						value={checkoutConfig.templateId}
						type={"text"}
						label={"Checkout template Id"}
						onChange={(e) => {
							onhandleConfigration(e.target.value, e.target.name, "checkpointConfig");
						}}
						error={error?.checkoutConfig?.templateId}
					/> */}
						<Input
							id={"buttonLabel"}
							name={"buttonLabel"}
							value={checkoutConfig.buttonLabel}
							type={"text"}
							label={"Button label"}
							onChange={(e) => {
								onhandleConfigration(e.target.value, e.target.name, "checkpointConfig");
							}}
							// required
							error={error?.checkoutConfig?.buttonLabel}
						/>
						<Input
							id={"submitFormTitle"}
							name={"submitFormTitle"}
							value={checkoutConfig.submitFormTitle}
							type={"text"}
							label={"Submit Form Title"}
							onChange={(e) => {
								onhandleConfigration(e.target.value, e.target.name, "checkpointConfig");
							}}
							// required
							error={error?.checkoutConfig?.submitFormTitle}
						/>
						<Input
							id={"entrySuccessText"}
							name={"entrySuccessText"}
							value={checkoutConfig.entrySuccessText}
							type={"text"}
							label={"Entry Success Text"}
							onChange={(e) => {
								onhandleConfigration(e.target.value, e.target.name, "checkpointConfig");
							}}
							// error={error?.checkoutConfig?.entrySuccessText}
						/>
						<div className="checkpoint-detail-container">
							<Checkbox
								id="isCheckoutCustomEndPoint"
								name="isCheckoutCustomEndPoint"
								checked={checkoutConfig.isCheckoutCustomEndPoint}
								label="Add Custom Checkout API Endpoints"
								onChange={(e) => {
									onhandleConfigration(e.target.checked, e.target.name, "checkpointConfig");
								}}
							/>
							{checkoutConfig.isCheckoutCustomEndPoint && (
								<section className="checkpoint-detail-container">
									<Input
										id={"checkoutConfig_apiMethod"}
										name={"apiMethod"}
										value={checkoutConfig.apiMethod}
										type={"text"}
										label={"API Method"}
										onChange={(e) => {
											onhandleConfigration(e.target.value, e.target.name, "checkpointConfig");
										}}
										required
										error={error?.checkoutConfig?.apiMethod}
									/>
									<div className="dropdown-div">
										<Dropdown
											id={"checkoutConfig_api"}
											name={"api"}
											// value={checkoutConfig.api ? (checkpointType.filter((ele) => ele.value === checkoutConfig.api))[0] : null}
											// options={checkpointType}
											value={
												ApiOption && ApiOption?.data && checkoutConfig.api
													? (ApiOption?.data.map((ele) => ({ label: ele.name, value: ele.endPoint })).filter((ele) => ele.value === checkoutConfig.api))[0]
													: null
											}
											options={ApiOption && ApiOption?.data ? ApiOption?.data.map((ele) => ({ label: ele.name, value: ele.endPoint })) : []}
											label={"Select API"}
											onChange={(option, key) => onhandleConfigration(option, key, "checkpointConfig")}
											required
											error={error?.checkoutConfig?.api}
										/>
									</div>
								</section>
							)}
						</div>
					</div>
				</AccordionWrapper>
			</div>
			<div className="d-flex justify-content-center my-4">
				<Button
					testId={"Submit"}
					text={isDuplicate ? "Submit" : updatedData && Object.keys(updatedData)?.length > 0 ? "Update" : "Submit"}
					style={{ ...buttonClasses.lynkitOrangeFill, width: "10%" }}
					// disabled={false}
					onClick={() => handleSubmit(isDuplicate ? "submit" : updatedData && Object.keys(updatedData)?.length > 0 ? "update" : "submit")}
				/>
			</div>
		</>
	);
}

const findVariableListing = (index, variableList, optionList) => {
	const currentList = variableList.length > 0 ? variableList[index] : null;
	if (currentList) {
		const currentValue = optionList.filter((ele) => ele.value === currentList)[0];
		return currentValue;
	}
	return [];
};

export const isValidLatitude = (lat) => {
	// Latitude range: -90 to 90
	const latRegex = /^-?([1-8]?[0-9](\.\d+)?|90(\.0+)?)$/;
	return latRegex.test(lat);
};

export const isValidLongitude = (lon) => {
	// Longitude range: -180 to 180
	const lonRegex = /^-?((1[0-7]|[1-9])?\d(\.\d+)?|180(\.0+)?)$/;
	return lonRegex.test(lon);
};

export const validatePayload = (payload) => {
	let success = true;
	const error = {
		checkPoint: {},
		listingConfig: [],
		approvalConfig: {},
		scanConfig: {},
		checkoutConfig: {},
		ledConfig: {
			variableList: [],
		},
		speakerConfig: {
			variableList: [],
		},
	};
	console.log('submit-validaiton', payload);
	//check checkpoint detail
	if (!payload.checkPoint.plantId) {
		error.checkPoint.plantId = "This field is required";
		success = false;
	}
	if(payload.checkPoint?.tripResetTimeLimit === 0){
		error.checkPoint.tripResetTimeLimit = "This field can't be zero.";
	}
	Object.keys(payload.checkPoint).forEach((ele) => {
		if (ele === "plantId") return;
		if (ele === "latitude" || ele === "longitude") {
			if (payload.checkPoint[ele] != "") {
				if (ele === "latitude" && !isValidLatitude(payload.checkPoint[ele])) {
					// console.log("Error in checkpoint latitude");
					error.checkPoint[ele] = "Please enter a valid latitude";
					success = false;
				}
				if (ele === "longitude" && !isValidLongitude(payload.checkPoint[ele])) {
					// console.log("Error in checkpoint longitude");
					error.checkPoint[ele] = "Please enter a valid longitude";
					success = false;
				}
			} else if ((ele === "latitude" && payload.checkPoint["longitude"] != "") || (ele === "longitude" && payload.checkPoint["latitude"] != "")) {
				error.checkPoint[ele] = "This field is required";
				success = false;
			} else {
				// error.checkPoint[ele] = "This field is required";
				// success = false;
				return;
			}
		}
		if (payload.checkPoint[ele] === "" && !["defaultWorkflowId", "templateId", "setupFunction", "postFunction"].includes(ele)) {
			error.checkPoint[ele] = "This field is required";
			success = false;
			// console.log("Error in checkpoint main");
		}
	});
	if (payload.checkPoint.isBidirectional && !payload.scanConfig.deviceScannning) {
		error.isBidirectional = "Device scanning is required for bidirectional";
		success = false;
	}

	//COMMENT THIS ONLY DEVICE SCANNING VALIDATION AS PER ATHAR ISSUE
	// if (payload.scanConfig.deviceScannning && !payload.scanConfig.deviceId) {
	// 	error.scanConfig.deviceId = "Device ID is required";
	// 	success = false;
	// }
	// if (payload.scanConfig.deviceScannning && payload.scanConfig.deviceId && !payload.scanConfig.antennaId) {
	// 	error.scanConfig.antennaId = "Antenna ID  is required";
	// 	success = false;
	// }


	// console.log(error)
	//check Listing Configuration
	// payload.listingConfig.forEach((ele, listIndex) => {
	// 	Object.keys(payload.listingConfig[listIndex]).forEach((ele, listItemIndex) => {
	// 		if (payload.listingConfig[listIndex][ele] === "" && !Array.isArray(payload.listingConfig[listIndex][ele])) {
	// 			error.listingConfig[listIndex] = { ...error.listingConfig[listIndex] };
	// 			error.listingConfig[listIndex][ele] = "This field is required";
	// 			success = false;
	// 		}
	// 		if (Array.isArray(payload.listingConfig[listIndex][ele])) {
	// 			error.listingConfig[listIndex] = { ...error.listingConfig[listIndex] };
	// 			error.listingConfig[listIndex]["filter"] = [];
	// 			const filter = payload.listingConfig[listIndex][ele];
	// 			filter.forEach((ele, filterIndex) => {
	// 				Object.keys(ele).forEach((filterItem, filterItemIndex) => {
	// 					if (ele[filterItem] === "" && ele[filterItem].constructor !== Object) {
	// 						error.listingConfig[listIndex]["filter"][filterIndex] = { ...error.listingConfig[listIndex]["filter"][filterIndex] };
	// 						error.listingConfig[listIndex]["filter"][filterIndex][filterItem] = "This field is required";
	// 						success = false;
	// 					}
	// 					if (ele[filterItem].constructor === Object) {
	// 						error.listingConfig[listIndex]["filter"][filterIndex] = { ...error.listingConfig[listIndex]["filter"][filterIndex] };
	// 						error.listingConfig[listIndex]["filter"][filterIndex]["formula"] = { eval: [] };
	// 						ele[filterItem].eval.forEach((formulaItem, formulaIndex) => {
	// 							Object.keys(formulaItem).forEach((evalItem, evalIndex) => {
	// 								if (formulaItem[evalItem] === "") {
	// 									error.listingConfig[listIndex]["filter"][filterIndex]["formula"]["eval"][formulaIndex] = {
	// 										...error.listingConfig[listIndex]["filter"][filterIndex]["formula"]["eval"][formulaIndex],
	// 									};
	// 									error.listingConfig[listIndex]["filter"][filterIndex]["formula"]["eval"][formulaIndex][evalItem] = "This field is required";
	// 									success = false;
	// 								}
	// 							});
	// 						});
	// 					}
	// 				});
	// 			});
	// 		}
	// 	});
	// });

	//check Approval Configuration
	if (payload.approvalConfig.sendApproval && payload.approvalConfig.dependentApproval) {
		// error.approvalConfig["approvaldependancy"] = [];
		payload.approvalConfig.approvaldependancy.forEach((ele, index) => {
			if (ele.itemType === "") {
				error.approvalConfig["approvaldependancy"][index] = { ...error.approvalConfig["approvaldependancy"][index], itemType: "This field is required" };
			}
			if (ele.id.length == 0) {
				error.approvalConfig["approvaldependancy"][index] = { ...error.approvalConfig["approvaldependancy"][index], id: "This field is required" };
			}
		});
	}

	//check Checkout Configuration

	Object.keys(payload.checkoutConfig).forEach((ele) => {
		// console.log(payload.checkoutConfig[ele], ele)
		if (payload.checkoutConfig.isCheckoutCustomEndPoint && ["apiMethod", "api"].includes(ele) && payload.checkoutConfig[ele] == "") {
			error.checkoutConfig[ele] = "This field is required";
			success = false;
		}
		if (payload.checkoutConfig.checkoutWhenOutOfRange && !payload.scanConfig.deviceScannning) {
			error.checkoutConfig["checkoutWhenOutOfRange"] = "Cannot use this checkout method if device scanning is disabled.";
			success = false;
		}
	});

	if (!payload.checkoutConfig.checkoutOnSubmit && !payload.checkoutConfig.autoCheckout && payload.checkoutConfig.templateId === "") {
		error.checkoutConfig["templateId"] = "If Checkout on Submit  and Auto Checkout  is unchecked, Template Id is required";
		success = false;
	}

	//check led config;
	if (payload.accessories.triggerLED.isActive === true) {
		if (payload.accessories.triggerLED.ledDetails.ledId === "") {
			error.ledConfig.ledId = "This field is required";
			success = false;
		}
		payload.accessories.triggerLED.ledDetails.eventTypes.forEach((eventType, index) => {
			if (!error.ledConfig.eventTypes) {
				error.ledConfig.eventTypes = [];
			}
			error.ledConfig.eventTypes[index] = {};

			if (eventType.type === "") {
				error.ledConfig.eventTypes[index].type = "This field is required";
				success = false;
			}
			if (eventType.lineOne === "") {
				error.ledConfig.eventTypes[index].lineOne = "This field is required";
				success = false;
			}

			// Validate variable list
			if (eventType.lineOne) {
				const range = findIndexForVariableList(eventType.lineOne);
				if (range?.length > 0) {
					error.ledConfig.eventTypes[index].variableList = [];
					range.forEach((_, varIndex) => {
						if (!eventType.variableList[varIndex]) {
							error.ledConfig.eventTypes[index].variableList[varIndex] = "This field is required";
							success = false;
						}
					});
				}
			}
		});
	}

	if (payload.accessories.triggerSpeaker.isActive === true) {
		if (payload.accessories.triggerSpeaker.speakerDetails.speakerId === "") {
			error.speakerConfig.speakerId = "This field is required";
			success = false;
		}
		payload.accessories.triggerSpeaker.speakerDetails.eventTypes.forEach((eventType, index) => {
			if (!error.speakerConfig.eventTypes) {
				error.speakerConfig.eventTypes = [];
			}
			error.speakerConfig.eventTypes[index] = {};

			if (eventType.type === "") {
				error.speakerConfig.eventTypes[index].type = "This field is required";
				success = false;
			}
			if (eventType.lineOne === "") {
				error.speakerConfig.eventTypes[index].lineOne = "This field is required";
				success = false;
			}

			// Validate variable list
			if (eventType.lineOne) {
				const range = findIndexForVariableList(eventType.lineOne);
				if (range?.length > 0) {
					error.speakerConfig.eventTypes[index].variableList = [];
					range.forEach((_, varIndex) => {
						if (!eventType.variableList[varIndex]) {
							error.speakerConfig.eventTypes[index].variableList[varIndex] = "This field is required";
							success = false;
						}
					});
				}
			}
		});
	}

	if (payload.accessories && typeof payload.accessories === "object") {
		const accessoriesArray = Array.isArray(payload.accessories) ? payload.accessories : Object.values(payload.accessories);
		error.accessories = [];

		accessoriesArray.forEach((accessory, index) => {
			error.accessories[index] = {};
			const isTriggerLED = "ledDetails" in accessory || accessory.accessoriesName === "triggerLED";
			const isTriggerSpeaker = "speakerDetails" in accessory || accessory.accessoriesName === "triggerSpeaker";
			if (isTriggerLED || isTriggerSpeaker) {
				return;
			}
			const accessoryName = accessory.accessoriesName || "";
			const accessoryData = accessory.accessoriesData || accessory;
			if (accessoryData.isActive) {
				if (!accessoryName) {
					error.accessories[index].accessoriesName = "Accessory name is required";
					success = false;
				}
				if (accessoryData.eventTypes) {
					error.accessories[index].eventTypes = [];
					accessoryData.eventTypes.forEach((eventType, eventIndex) => {
						error.accessories[index].eventTypes[eventIndex] = {};
						if (!eventType.type) {
							error.accessories[index].eventTypes[eventIndex].type = "Event type is required";
							success = false;
						}
						if (eventType.duration === undefined || eventType.duration === null || isNaN(eventType.duration)) {
							error.accessories[index].eventTypes[eventIndex].duration = "Duration is required and must be a number";
							success = false;
						}
					});
				}
			}
		});
	}

	// console.log('submit-validaiton-error', error)
	return { error: error, success: success };
};

const antennaValue = (antennaValue, devices, deviceValue) => {
	// console.log(antennaValue, devices, deviceValue);
	const selectedDevice = devices.find((ele) => ele.imei === deviceValue);
	const activeAntennas = selectedDevice ? selectedDevice.antenna.filter((ele) => ele.status === "Active") : [];
	const selectedAntenna = activeAntennas.find((ele) => ele.antennanumber == antennaValue);

	const value = selectedAntenna ? { label: `${selectedAntenna.action} (${selectedAntenna.antennanumber})`, value: selectedAntenna.antennanumber } : null;
	const options = activeAntennas.map((ele) => ({ label: `${ele.action} (${ele.antennanumber})`, value: ele.antennanumber }));
	return value;
};

export const filterOption = (rawOption, selectedOption) => {
	// console.log('item option', rawOption, selectedOption)
	return rawOption?.filter((chk) => selectedOption?.find((fchk) => fchk == chk.value));
};

function ensureValueIsArray(filter) {
	filter.forEach((obj) => {
		processFilter(obj.filter);
	});
	return filter;
}

const findIndexForVariableList = (str) => {
	// const str = '{0} is active {1}';
	const arr = str.split(" ");
	let result = [];
	arr.forEach((ele, index) => {
		if (ele.match(/\{\d+\}/)) {
			result.push({ element: ele, Index: index });
		}
	});
	return result.filter((item, index, self) => index === self.findIndex((t) => t.element === item.element));
};

function processFilter(filters) {
	filters.forEach((filterObj) => {
		if (filterObj.formula) {
			if (filterObj.formula.operator === "object" && Array.isArray(filterObj.formula.eval)) {
				filterObj.formula.eval.forEach((evalObj) => {
					if (evalObj.isDynamic === false && ["$in", "$nin"].includes(evalObj.key)) {
						if (!Array.isArray(evalObj.value)) {
							evalObj.value = [evalObj.value];
						}
					}
				});
			}
			if (filterObj.formula.operator === "array" && Array.isArray(filterObj.formula.subFilter)) {
				processFilter(filterObj.formula.subFilter);
			}
		}
	});
}

const ItemTypes = {
	ACCESSORY: "accessory",
};
const DraggableAccessory = ({ id, index, moveItem, children }) => {
	const ref = useRef(null);

	const [, drop] = useDrop({
		accept: ItemTypes.ACCESSORY,
		hover(item) {
			if (item.index === index) return;
			moveItem(item.index, index);
			item.index = index;
		},
	});

	const [{ isDragging }, drag] = useDrag({
		type: ItemTypes.ACCESSORY,
		item: { id, index },
		collect: (monitor) => ({
			isDragging: monitor.isDragging(),
		}),
	});

	drag(drop(ref));

	return (
		<div ref={ref} style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
			<div ref={drag} style={{ cursor: "move" }}>
				<DragIndicatorIcon style={{ fill: "var(--text-color)", marginTop: "2px" }} />
			</div>
			{children}
		</div>
	);
};

// for In and Not In
function undoArrayToString(listingConfig) {
	listingConfig.forEach((_) => undoArrayProcessFilter(_.filter));
	return listingConfig;
}
function undoArrayProcessFilter(filters) {
	filters.forEach((filterObj) => {
		if (filterObj.formula) {
			if (filterObj.formula.operator === "object" && Array.isArray(filterObj.formula.eval)) {
				filterObj.formula.eval.forEach((evalObj) => {
					if (evalObj.isDynamic === false && ["$in", "$nin"].includes(evalObj.key) && Array.isArray(evalObj.value)) {
						// if (!Array.isArray(evalObj.value)) {
						// evalObj.value = [evalObj.value];
						// }
						evalObj.value = evalObj.value[0];
					}
				});
			}
			if (filterObj.formula.operator === "array" && Array.isArray(filterObj.formula.subFilter)) {
				undoArrayProcessFilter(filterObj.formula.subFilter);
			}
		}
	});
}
